// assets/archoil-quiz.js
// VERSION: 2.2 (27 Oct 2026) - live Shopify prices/images + legacy WDFK reporting name
//   - Email step redesigned: 10% off message, email first, optional mobile box, skip as a text link
//   - Name field removed from the email step (set FEATURES.gateName to true to bring it back above email)
//   - Drop-off tracking: page view, one event per question shown, and the email step (Klaviyo + GA4)
//   - Meta Pixel standard Lead event sent when an email is accepted (once per browser session)
//   v2.1: mobile line reads "deals by text" (was "text-only deals")

// loader flag (proves the asset executed at all)
window.__archoil_quiz_loaded = true;

(function () {
  'use strict';

  /* ----------------------- Klaviyo configuration (public) ----------------------- */
  var KLAVIYO_SITE_ID = (window.ARCHOIL_KLAVIYO_SITE_ID || 'SwSu9D').trim();
  var KLAVIYO_LIST_ID = (window.ARCHOIL_KLAVIYO_LIST_ID || 'SH7ZZd').trim();

  /* -------------------- Feature flags -------------------- */
  var FEATURES = { icons: true, upsell: false, gate: true, gateName: false }; // GATE: ON · gateName: show a Name field above Email on the email step

  /* -------------------- Full-screen hero images (override via window.ARCHOIL_QUIZ_HERO_IMAGES) ------- */
  var HERO_IMAGES = Object.assign({
    default:      'https://cdn.shopify.com/s/files/1/1997/2921/files/Intro_bf4b097d-0bf0-4809-9037-6e279235492e.jpg?v=1762358681',
    intro:        'https://cdn.shopify.com/s/files/1/1997/2921/files/Intro_bf4b097d-0bf0-4809-9037-6e279235492e.jpg?v=1762358681',
    results:      'https://cdn.shopify.com/s/files/1/1997/2921/files/Results.jpg?v=1759845830',
    q1_engine:    'https://cdn.shopify.com/s/files/1/1997/2921/files/Engine.jpg?v=1759844532',
    d2_vehicle:   'https://cdn.shopify.com/s/files/1/1997/2921/files/D_Vehicle.jpg?v=1759844532',
    d3_miles:     'https://cdn.shopify.com/s/files/1/1997/2921/files/Milage.jpg?v=1759844532',
    d4_benefits:  'https://cdn.shopify.com/s/files/1/1997/2921/files/Benefit.jpg?v=1759844532',
    d5_use:       'https://cdn.shopify.com/s/files/1/1997/2921/files/Use_f9927ec0-a25e-4d31-a7d2-5b90e03d23a0.jpg?v=1765208044',
    d6_cold:      'https://cdn.shopify.com/s/files/1/1997/2921/files/Cold.jpg?v=1759844533',
    d7_multi:     'https://cdn.shopify.com/s/files/1/1997/2921/files/Multi_5a0556ee-1464-4a93-8a92-2cc958305baf.jpg?v=1759927393',
    g2_vehicle:   'https://cdn.shopify.com/s/files/1/1997/2921/files/G_Vehicle.jpg?v=1759844533',
    g3_miles:     'https://cdn.shopify.com/s/files/1/1997/2921/files/Milage.jpg?v=1759844532',
    g4_benefits:  'https://cdn.shopify.com/s/files/1/1997/2921/files/Benefit.jpg?v=1759844532',
    g5_use:       'https://cdn.shopify.com/s/files/1/1997/2921/files/Use_G.jpg?v=1765209019',
    g6_multi:     'https://cdn.shopify.com/s/files/1/1997/2921/files/Multi_5a0556ee-1464-4a93-8a92-2cc958305baf.jpg?v=1759927393'
  }, (window.ARCHOIL_QUIZ_HERO_IMAGES || {}));

  /* -------------------------- tiny utils -------------------------- */
  function showError(msg){
    try{
      var root = document.getElementById('archoil-quiz-root');
      if(!root) return;
      root.innerHTML =
        '<div style="max-width:52rem;margin:2rem auto;padding:1rem 1.25rem;border:1px solid #fde2cf;background:#fff7ed;color:#7c2d12;border-radius:12px">'+
        '<div style="font-weight:700;margin-bottom:6px;">Quiz failed to load</div>'+
        '<div style="font-size:14px;line-height:1.5">'+ String(msg||'Unknown error') +'</div></div>';
    }catch(e){}
  }
  function byId(id){ return document.getElementById(id); }
  function el(tag, attrs, children){
    var d=document.createElement(tag);
    if(attrs) for(var k in attrs){
      if(k==='class') d.className=attrs[k];
      else if(k==='style') d.setAttribute('style',attrs[k]);
      else if(k.startsWith('on') && typeof attrs[k]==='function') d.addEventListener(k.substring(2),attrs[k]);
      else d.setAttribute(k,attrs[k]);
    }
    (children||[]).forEach(function(c){ d.appendChild(typeof c==='string'? document.createTextNode(c): c); });
    return d;
  }
  function clear(n){ while(n.firstChild) n.removeChild(n.firstChild); }
  function scrollTop(){
    try{
      var root=document.getElementById('archoil-quiz-root');
      if(root){ var y=root.getBoundingClientRect().top+window.pageYOffset-8; window.scrollTo({top:y,behavior:'smooth'}); }
    }catch(e){}
  }
  function setVhVar(){ try{ var vh = window.innerHeight * 0.01; document.documentElement.style.setProperty('--vh', vh + 'px'); }catch(_){ } }
  setVhVar(); window.addEventListener('resize', setVhVar);

  window.archoilQuizGateOk = !FEATURES.gate; // if gate disabled, results show immediately

  // ---- Saved results snapshot (for "Return to my recommendations")
  var LAST_RESULTS_KEY = 'archoil_quiz_last_results_v1';
  function saveLastResults(snapshot){
    try { localStorage.setItem(LAST_RESULTS_KEY, JSON.stringify(snapshot)); } catch(_){}
  }
  function loadLastResults(){
    try {
      var raw = localStorage.getItem(LAST_RESULTS_KEY);
      if(!raw) return null;
      var s = JSON.parse(raw);
      if(!s || !s.results || !s.results.length) return null;
      if (s.ts && (Date.now() - s.ts > 30*24*60*60*1000)) return null; // expire after 30 days
      return s;
    } catch(_) { return null; }
  }

  /* ---------------- persistence ---------------- */
  var STORAGE_KEY='archoil_quiz_state_v2';
  function isAnswered(q, answers){
    var v = answers[q.id];
    return q.type==='multi' ? (Array.isArray(v) && v.length>0) : (v!=null && v!=='');
  }
  function persist(){ try{ localStorage.setItem(STORAGE_KEY, JSON.stringify({answers: state.answers})); }catch(e){} }
  function restore(){ try{ var s=JSON.parse(localStorage.getItem(STORAGE_KEY)||'null'); if(s && s.answers) state.answers=s.answers; }catch(e){} }

  // winter helper (Nov–Jan)
  function isWinterMonth(){
    try{ var m=(new Date()).getMonth(); return (m===10||m===11||m===0); }catch(e){ return false; }
  }
  function isColdScenario(a){
    try{
      if (!a || a.q1_engine !== 'diesel') return false;
      var coldYes = (a.d6_cold === 'yes');
      var wantsAG = Array.isArray(a.d4_benefits) && a.d4_benefits.indexOf('anti_gel') > -1;
      // NEW: OR rule for "sometimes"
      var eligibleSometimes = (a.d6_cold === 'sometimes') && (isWinterMonth() || wantsAG);
      return coldYes || eligibleSometimes;
    }catch(_){ return false; }
  }

  /* -------------------- Icons -------------------- */
  var ICONS = {
    "engine:diesel":   "https://cdn.shopify.com/s/files/1/1997/2921/files/Diesel.png?v=1755177827",
    "engine:gasoline": "https://cdn.shopify.com/s/files/1/1997/2921/files/Gasoline.png?v=1755177827",
    "setup:heavy":        "https://cdn.shopify.com/s/files/1/1997/2921/files/heavy_duty.png?v=1755177827",
    "setup:older":        "https://cdn.shopify.com/s/files/1/1997/2921/files/older.png?v=1755177827",
    "setup:newer":        "https://cdn.shopify.com/s/files/1/1997/2921/files/newer.png?v=1755177827",
    "setup:ag_offroad":   "https://cdn.shopify.com/s/files/1/1997/2921/files/Agriculture.png?v=1757495496",
    "setup:daily":        "https://cdn.shopify.com/s/files/1/1997/2921/files/daily_driver.png?v=1755177827",
    "setup:classic":      "https://cdn.shopify.com/s/files/1/1997/2921/files/Classic.png?v=1757495496",
    "setup:perf_lux":     "https://cdn.shopify.com/s/files/1/1997/2921/files/Performance.png?v=1757495496",
    "setup:recreational": "https://cdn.shopify.com/s/files/1/1997/2921/files/Boats.png?v=1757495496",
    "setup:powerstroke":  "https://cdn.shopify.com/s/files/1/1997/2921/files/Powerstroke.png?v=1757495496",
    "setup:class8":      "https://cdn.shopify.com/s/files/1/1997/2921/files/SemiTruck.png?v=1760956148",
    "miles:0_20k":     "https://cdn.shopify.com/s/files/1/1997/2921/files/0-20k.png?v=1761583667",
    "miles:20_50k":    "https://cdn.shopify.com/s/files/1/1997/2921/files/20-50k.png?v=1761583667",
    "miles:50_100k":    "https://cdn.shopify.com/s/files/1/1997/2921/files/50-100k_15499a66-dd46-48cd-9d21-6400d3da9bda.png?v=1761583667",
    "miles:100k_plus":  "https://cdn.shopify.com/s/files/1/1997/2921/files/100k_55eca44d-c03a-47ee-b6f2-bd6a04087e1a.png?v=1761583667",
    "goal:improved_mpg":   "https://cdn.shopify.com/s/files/1/1997/2921/files/MPG.png?v=1757495496",
    "goal:lifespan":       "https://cdn.shopify.com/s/files/1/1997/2921/files/Extend.png?v=1757495496",
    "goal:reduced_dpf":    "https://cdn.shopify.com/s/files/1/1997/2921/files/DPF.png?v=1757495496",
    "goal:cetane":         "https://cdn.shopify.com/s/files/1/1997/2921/files/Cetane_1e7f3cdc-80ec-4c62-9432-d275abfe21b6.png?v=1757495496",
    "goal:stiction":       "https://cdn.shopify.com/s/files/1/1997/2921/files/Stiction.png?v=1757495496",
    "goal:anti_gel":       "https://cdn.shopify.com/s/files/1/1997/2921/files/Anti-gel.png?v=1757495496",
    "goal:power_response": "https://cdn.shopify.com/s/files/1/1997/2921/files/Power.png?v=1757495496",
    "goal:reduce_smoke":   "https://cdn.shopify.com/s/files/1/1997/2921/files/Smoke.png?v=1757495496",
    "goal:reduce_maint":   "https://cdn.shopify.com/s/files/1/1997/2921/files/Costs.png?v=1757495496",
    "goal:reduce_knock":   "https://cdn.shopify.com/s/files/1/1997/2921/files/Pinging.png?v=1757495496",
    "recency:never":   "https://cdn.shopify.com/s/files/1/1997/2921/files/Never_e2610f99-5e53-41d9-8ffd-8266d0cceb2f.png?v=1757495557",
    "recency:recent":  "https://cdn.shopify.com/s/files/1/1997/2921/files/Recently.png?v=1757495496",
    "recency:regular": "https://cdn.shopify.com/s/files/1/1997/2921/files/Yes.png?v=1757495496",
    "cold:yes":        "https://cdn.shopify.com/s/files/1/1997/2921/files/Cold.png?v=1757495496",
    "cold:sometimes":  "https://cdn.shopify.com/s/files/1/1997/2921/files/Sometimes.png?v=1757495497",
    "cold:no":         "https://cdn.shopify.com/s/files/1/1997/2921/files/Warm_e53a945a-ca56-4f85-9a05-4a0206587a80.png?v=1757495496",
    "multi:yes": "https://cdn.shopify.com/s/files/1/1997/2921/files/Lawnmower.png?v=1757495496",
    "multi:no":  "https://cdn.shopify.com/s/files/1/1997/2921/files/Never_e2610f99-5e53-41d9-8ffd-8266d0cceb2f.png?v=1757495557"
  };
  function iconKeyForOption(qid, oid){
    switch (qid) {
      case 'q1_engine': return 'engine:' + oid;
      case 'd2_vehicle':
  if (oid==='heavy_diesel') return 'setup:heavy';
  if (oid==='ag_offroad')   return 'setup:ag_offroad';
  if (oid==='class8_commercial') return 'setup:class8';
  if (oid==='daily_driver')  return 'setup:daily';
  if (oid==='recreational')  return 'setup:recreational';
  if (oid==='powerstroke_6_0_7_3') return 'setup:powerstroke';
  break;

      case 'g2_vehicle':
        if (oid==='daily_driver')  return 'setup:daily';
        if (oid==='older_gas')     return 'setup:older';
        if (oid==='newer_gas')     return 'setup:newer';
        if (oid==='classic')       return 'setup:classic';
        if (oid==='perf_lux')      return 'setup:perf_lux';
        if (oid==='recreational')  return 'setup:recreational';
        break;
      case 'd3_miles':
      case 'g3_miles': return 'miles:' + oid;
      case 'd4_benefits':
      case 'g4_benefits': return 'goal:' + oid;
      case 'd5_use':
      case 'g5_use':
        if (oid==='never')        return 'recency:never';
        if (oid==='occasionally') return 'recency:recent';
        if (oid==='regularly')    return 'recency:regular';
        break;
      case 'd6_cold': return 'cold:' + oid;
      case 'd7_multi':
      case 'g6_multi': return 'multi:' + oid;
    }
    return qid + ':' + oid;
  }
  function renderIconElement(key, label){
    var src = ICONS[key];
    if (typeof src === 'string' && src.trim()) return el('img', { class:'aq-icon', src: src, alt: '' }, []);
    var initial = (label||' ')[0].toUpperCase();
    return el('div', { class:'aq-initial', 'aria-hidden':'true', title:label }, [initial]);
  }

  /* --------------------------------- CONFIG ---------------------------------- */
  var CONFIG = {
  questions: [
    { id:"q1_engine", order:1, type:"single", required:true, title:"What type of engine are you looking to treat?" },
    // DIESEL
    { id:"d2_vehicle",  order:2, type:"single", required:true, title:"What best describes the vehicle you're looking to treat?", show_when:{ q1_engine:["diesel"] } },
    { id:"d3_miles",    order:3, type:"single", required:true, title:"How many miles are on your vehicle?",                     show_when:{ q1_engine:["diesel"] } },
    { id:"d4_benefits", order:4, type:"multi",  required:true, title:"Which benefits mean the most to you? (Choose up to 3)",  max_select:3, show_when:{ q1_engine:["diesel"] } },
    { id:"d5_use",      order:5, type:"single", required:true, title:"How often do you use fuel system or engine treatments?", show_when:{ q1_engine:["diesel"] } },
    { id:"d6_cold",     order:6, type:"single", required:true, title:"Do you drive in conditions where diesel fuel can gel (temperatures consistently below 32°F / 0°C)?", show_when:{ q1_engine:["diesel"] } },
    { id:"d7_multi",    order:7, type:"single", required:true, title:"Do you own multiple vehicles or equipment?",             show_when:{ q1_engine:["diesel"] } },
    // GASOLINE
    { id:"g2_vehicle",  order:2, type:"single", required:true, title:"What best describes the vehicle you're looking to treat?", show_when:{ q1_engine:["gasoline"] } },
    { id:"g3_miles",    order:3, type:"single", required:true, title:"How many miles are on your vehicle?",                      show_when:{ q1_engine:["gasoline"] } },
    { id:"g4_benefits", order:4, type:"multi",  required:true, title:"Which benefits mean the most to you? (Choose up to 3)",   max_select:3, show_when:{ q1_engine:["gasoline"] } },
    { id:"g5_use",      order:5, type:"single", required:true, title:"How often do you use fuel system or engine treatments?",  show_when:{ q1_engine:["gasoline"] } },
    { id:"g6_multi",    order:6, type:"single", required:true, title:"Do you own multiple vehicles or equipment?",              show_when:{ q1_engine:["gasoline"] } }
  ],
  options: [
    // Q1
    {question_id:"q1_engine", option_id:"diesel",   label:"Diesel"},
    {question_id:"q1_engine", option_id:"gasoline", label:"Gasoline"},

    // Diesel vehicle (REPLACED older/newer with daily_driver, recreational)
    {question_id:"d2_vehicle", option_id:"heavy_diesel",       label:"Light / Heavy duty diesel truck"},
    {question_id:"d2_vehicle", option_id:"class8_commercial",  label:"Class 8 Semi-Truck/ Commercial Vehicle"},
    {question_id:"d2_vehicle", option_id:"daily_driver",       label:"Daily driver car / SUV"},
    {question_id:"d2_vehicle", option_id:"recreational",       label:"Recreational or specialty (boats, RV, etc)"},
    {question_id:"d2_vehicle", option_id:"ag_offroad",         label:"Agricultural or off-road diesel equipment"},
    {question_id:"d2_vehicle", option_id:"powerstroke_6_0_7_3",label:"6.0L or 7.3L Power Stroke"},

    // Diesel miles (ADDED 0-20k, CHANGED 0-50k → 20-50k)
    {question_id:"d3_miles", option_id:"0_20k",     label:"0 - 20,000"},
    {question_id:"d3_miles", option_id:"20_50k",    label:"20,000 - 50,000"},
    {question_id:"d3_miles", option_id:"50_100k",   label:"50,000 - 100,000"},
    {question_id:"d3_miles", option_id:"100k_plus", label:"100,000+"},

    // Diesel benefits (REPLACED 'reduce_smoke' → 'reduce_maint')
    {question_id:"d4_benefits", option_id:"improved_mpg",   label:"Improved MPG"},
    {question_id:"d4_benefits", option_id:"lifespan",       label:"Improved engine and component lifespan"},
    {question_id:"d4_benefits", option_id:"reduced_dpf",    label:"Reduced DPF regen frequency"},
    {question_id:"d4_benefits", option_id:"cetane",         label:"Increased cetane rating"},
    {question_id:"d4_benefits", option_id:"anti_gel",       label:"Anti-gel protection"},
    {question_id:"d4_benefits", option_id:"power_response", label:"Improved power and response"},
    {question_id:"d4_benefits", option_id:"reduce_maint",   label:"Reduced maintenance costs"},
    {question_id:"d4_benefits", option_id:"stiction",       label:"Stiction fix (6.0L & 7.3L Power Stroke)"},

    {question_id:"d5_use", option_id:"never",       label:"Never or rarely"},
    {question_id:"d5_use", option_id:"occasionally",label:"Occasionally"},
    {question_id:"d5_use", option_id:"regularly",   label:"Regularly"},

    {question_id:"d6_cold", option_id:"yes",       label:"Yes - I regularly drive in freezing conditions"},
    {question_id:"d6_cold", option_id:"sometimes", label:"Sometimes - regular cold snaps in the winter"},
    {question_id:"d6_cold", option_id:"no",        label:"No - it's usually above freezing"},

    {question_id:"d7_multi", option_id:"yes", label:"Yes (cars, trucks, ATVs, boats, etc)"},
    {question_id:"d7_multi", option_id:"no",  label:"No"},

    // Gasoline vehicle (unchanged)
    {question_id:"g2_vehicle", option_id:"daily_driver", label:"Daily driver car/SUV/truck"},
    {question_id:"g2_vehicle", option_id:"older_gas",    label:"Older gasoline vehicle with reduced performance"},
    {question_id:"g2_vehicle", option_id:"newer_gas",    label:"Newer gasoline vehicle I want to keep in top condition"},
    {question_id:"g2_vehicle", option_id:"classic",      label:"Classic car"},
    {question_id:"g2_vehicle", option_id:"perf_lux",     label:"Performance or luxury vehicle"},
    {question_id:"g2_vehicle", option_id:"recreational", label:"Recreational or specialty (boats, ATVs, motorcycles)"},

    // Gasoline miles (ADDED 0-20k, CHANGED 0-50k → 20-50k)
    {question_id:"g3_miles", option_id:"0_20k",     label:"0 - 20,000"},
    {question_id:"g3_miles", option_id:"20_50k",    label:"20,000 - 50,000"},
    {question_id:"g3_miles", option_id:"50_100k",   label:"50,000 - 100,000"},
    {question_id:"g3_miles", option_id:"100k_plus", label:"100,000+"},

    // Gasoline benefits (unchanged)
    {question_id:"g4_benefits", option_id:"improved_mpg",   label:"Improved MPG"},
    {question_id:"g4_benefits", option_id:"lifespan",       label:"Improved engine and component lifespan"},
    {question_id:"g4_benefits", option_id:"reduce_maint",   label:"Reduced maintenance costs"},
    {question_id:"g4_benefits", option_id:"power_response", label:"Improved power and response"},
    {question_id:"g4_benefits", option_id:"reduce_knock",   label:"Reduced engine knocking / pinging"},
    {question_id:"g4_benefits", option_id:"reduce_smoke",   label:"Reduced emissions / smoke"},

    {question_id:"g5_use", option_id:"never",       label:"Never or rarely"},
    {question_id:"g5_use", option_id:"occasionally",label:"Occasionally"},
    {question_id:"g5_use", option_id:"regularly",   label:"Regularly"},

    {question_id:"g6_multi", option_id:"yes", label:"Yes (cars, trucks, ATVs, boats, etc)"},
    {question_id:"g6_multi", option_id:"no",  label:"No"}
  ],
  products: [
    { id:"AR6500",   name:"AR6500 Diesel Treatment",               url:"https://www.archoil.com/products/ar6500-diesel-treatment",                         image:"https://cdn.shopify.com/s/files/1/1997/2921/files/AR6500_c8d8f8d7-0710-410c-81c0-a22921455077.jpg?v=1764666678", blurb:"Use at every fill-up for maximum performance." },
    { id:"AR6400-D", name:"AR6400-D Diesel Fuel System Cleaner",   url:"https://www.archoil.com/products/ar6400-d-diesel-fuel-system-cleaner",             image:"https://www.archoil.com/cdn/shop/files/AR6400-D_b2b3548e-cefd-4f26-9890-0df21af91436.jpg?v=1751639627&width=1080", blurb:"One tank rapid diesel restoraton." },
    { id:"AR6300",   name:"AR6300 Winter Diesel Treatment",        url:"https://www.archoil.com/products/ar6300-winter-diesel-treatment",                  image:"https://cdn.shopify.com/s/files/1/1997/2921/files/6300_91e5133b-4e1f-4052-ad42-3863f308ffcd.jpg?v=1764666866", blurb:"Use at every fill-up for maximum diesel power plus anti-gel protection." },
    { id:"AR6400-G", name:"AR6400-G Gasoline Fuel System Cleaner", url:"https://www.archoil.com/products/ar6400-g-gasoline-fuel-system-cleaner",           image:"https://www.archoil.com/cdn/shop/files/AR6400-G.jpg?v=1730381812&width=1080", blurb:"One tank rapid gasoline restoration." },
    { id:"AR6200",   name:"AR6200 Fuel Treatment",                 url:"https://www.archoil.com/products/ar6200-fuel-treatment",                           image:"https://www.archoil.com/cdn/shop/files/AR6200.jpg?v=1730381811&width=1080", blurb:"Use at every fill-up to improve fuel quality and combustion efficiency." },
    { id:"AR9100",   name:"AR9100 Friction Modifier",              url:"https://www.archoil.com/products/ar9100-oil-additive",                             image:"https://cdn.shopify.com/s/files/1/1997/2921/files/AR9100_4a2e33fa-654a-4e1e-8107-5b2e5a16fa81.jpg?v=1764666914", blurb:"Regain power, response & eliminate 6.0/7.3L Power Stroke stiction." },
    { id:"DFSK",     name:"Diesel Fuel System Kit",                url:"https://www.archoil.com/products/dfsk-2",                                           image:"https://cdn.shopify.com/s/files/1/1997/2921/files/DFSK_4409691f-23e4-411b-9c08-717857a2f71b.jpg?v=1764666604", blurb:"Complete fuel system restoration." },
    { id:"GFSK",     name:"Gas Fuel System Kit",                   url:"https://www.archoil.com/products/ar6200-fuel-treatment?variant=40215842127954",    image:"https://cdn.shopify.com/s/files/1/1997/2921/files/6400-G_6200.jpg?v=1757345895", blurb:"Complete gasoline fuel system restoration." },
    { id:"UDK",      name:"Ultimate Diesel Kit",                   url:"https://www.archoil.com/products/udk",                                             image:"https://cdn.shopify.com/s/files/1/1997/2921/files/UDK_aff9efe5-869b-4cea-ac93-d5749bdaeb88.jpg?v=1764666537", blurb:"Total performance and protection." },
    { id:"WDFK",     name:"Winter Diesel Kit", reporting_name:"Winter Diesel Fuel Kit",                     url:"https://www.archoil.com/products/winter-diesel-kit", image:"https://www.archoil.com/cdn/shop/files/WDK_-_Save_5_99a5bae0-fa80-4ab3-a755-8144974627df.jpg?v=1792422429", blurb:"Complete fuel system restoration in cold weather." },
    { id:"UWDK",     name:"Ultimate Winter Diesel Kit",            url:"https://www.archoil.com/products/ar6300-winter-diesel-treatment?variant=40215826792530", image:"https://cdn.shopify.com/s/files/1/1997/2921/files/UWDK_a09c9309-06a7-4904-a6bb-a456f6148960.jpg?v=1762357081", blurb:"Total cold weather performance and protection." }
  ],
  exclusions: [
    { condition:"q1_engine=gasoline", exclude_product_id:"AR6500"   },
    { condition:"q1_engine=gasoline", exclude_product_id:"AR6400-D" },
    { condition:"q1_engine=gasoline", exclude_product_id:"AR6300"   },
    { condition:"q1_engine=diesel",   exclude_product_id:"AR6400-G" },
    { condition:"d6_cold=no",         exclude_product_id:"AR6300"   },
    { condition:"q1_engine=gasoline", exclude_product_id:"DFSK"     },
    { condition:"q1_engine=diesel",   exclude_product_id:"GFSK"     },
    { condition:"q1_engine=gasoline", exclude_product_id:"UDK"      },
    { condition:"q1_engine=gasoline", exclude_product_id:"WDFK"     },
    { condition:"q1_engine=gasoline", exclude_product_id:"UWDK"     }
  ],
  settings: [ { key:"always_include_top_n", value:"3" } ],
  kits: {}
};


  /* ---------------- relevance matrix (shortened comment) ---------------- */
  var REL = {
    q1_engine: {
      diesel:   { "AR6500":5, "AR6400-D":5, "AR6300":5, "AR9100":2, "AR6200":0, "AR6400-G":0, "DFSK":5, "GFSK":0 },
      gasoline: { "AR6500":0, "AR6400-D":0, "AR6300":0, "AR9100":2, "AR6200":5, "AR6400-G":5, "DFSK":0, "GFSK":4 }
    },
    d2_vehicle: {
      heavy_diesel:{ "AR6500":4, "AR6400-D":3, "AR6300":3, "AR9100":4, "DFSK":4 },
      daily_driver:{ "AR6500":5, "AR6400-D":2, "AR6300":3, "AR9100":1, "DFSK":4 },
      recreational:{ "AR6500":4, "AR6400-D":3, "AR6300":3, "AR9100":1, "DFSK":4 },
      ag_offroad:  { "AR6500":4, "AR6400-D":3, "AR6300":4, "AR9100":2, "DFSK":4 },
      class8_commercial: { "AR6500":4, "AR6400-D":3, "AR6300":3, "AR9100":4, "DFSK":4 },
      powerstroke_6_0_7_3: { "AR6500":4, "AR6400-D":3, "AR6300":3, "AR9100":6, "DFSK":4 }
    },
    d3_miles: {
      "0_20k":     { "AR6500":5, "AR6400-D":2, "AR6300":2, "AR9100":2, "DFSK":1 },
      "20_50k":    { "AR6500":3, "AR6400-D":2, "AR6300":2, "AR9100":2, "DFSK":3 },
      "50_100k":   { "AR6500":3, "AR6400-D":4, "AR6300":3, "AR9100":3, "DFSK":4 },
      "100k_plus": { "AR6500":3, "AR6400-D":5, "AR6300":3, "AR9100":3, "DFSK":4 }
    },
    d4_benefits: {
      improved_mpg:   { "AR6500":4, "AR6400-D":1, "AR6300":1, "AR9100":1, "DFSK":5 },
      lifespan:       { "AR6500":2, "AR6400-D":2, "AR6300":1, "AR9100":2, "DFSK":4 },
      reduced_dpf:    { "AR6500":3, "AR6400-D":1, "AR6300":3, "AR9100":0, "DFSK":3 },
      cetane:         { "AR6500":3, "AR6400-D":0, "AR6300":0, "AR9100":0, "DFSK":4 },
      stiction:       { "AR6500":0, "AR6400-D":1, "AR6300":0, "AR9100":6, "DFSK":1 },
      anti_gel:       { "AR6500":0, "AR6400-D":0, "AR6300":6, "AR9100":0, "DFSK":0 },
      power_response: { "AR6500":3, "AR6400-D":4, "AR6300":1, "AR9100":0, "DFSK":3 },
      reduce_maint:   { "AR6500":3, "AR6400-D":3, "AR6300":1, "AR9100":1, "DFSK":4 }
    },
    d5_use: {
      never:       { "AR6500":1, "AR6400-D":4, "AR6300":1, "AR9100":1, "DFSK":4 },
      occasionally:{ "AR6500":2, "AR6400-D":3, "AR6300":1, "AR9100":1, "DFSK":4 },
      regularly:   { "AR6500":4, "AR6400-D":1, "AR6300":1, "AR9100":1, "DFSK":3 }
    },
    d6_cold: {
      yes:        { "AR6500":0, "AR6400-D":0, "AR6300":6, "AR9100":1, "DFSK":0 },
      sometimes:  { "AR6500":3, "AR6400-D":0, "AR6300":3, "AR9100":1, "DFSK":2 },
      no:         { "AR6500":4, "AR6400-D":4, "AR6300":0, "AR9100":1, "DFSK":4 }
    },
    d7_multi: { yes:{}, no:{} },

    g2_vehicle: {
      daily_driver:{ "AR6200":4, "AR6400-G":2, "AR9100":1, "GFSK":4 },
      older_gas:   { "AR6200":2, "AR6400-G":5, "AR9100":2, "GFSK":4 },
      newer_gas:   { "AR6200":5, "AR6400-G":2, "AR9100":1, "GFSK":5 },
      classic:     { "AR6200":3, "AR6400-G":5, "AR9100":2, "GFSK":5 },
      perf_lux:    { "AR6200":5, "AR6400-G":2, "AR9100":1, "GFSK":5 },
      recreational:{ "AR6200":4, "AR6400-G":3, "AR9100":1, "GFSK":3 }
    },
    g3_miles: {
      "0_20k":     { "AR6200":5, "AR6400-G":2, "AR9100":1, "GFSK":2 },
      "20_50k":    { "AR6200":4, "AR6400-G":2, "AR9100":1, "GFSK":3 },
      "50_100k":   { "AR6200":3, "AR6400-G":4, "AR9100":1, "GFSK":4 },
      "100k_plus": { "AR6200":3, "AR6400-G":5, "AR9100":1, "GFSK":5 }
    },
    g4_benefits: {
      improved_mpg:   { "AR6200":4, "AR6400-G":2, "AR9100":1, "GFSK":3 },
      lifespan:       { "AR6200":3, "AR6400-G":2, "AR9100":2, "GFSK":3 },
      reduce_maint:   { "AR6200":3, "AR6400-G":3, "AR9100":1, "GFSK":3 },
      power_response: { "AR6200":3, "AR6400-G":4, "AR9100":1, "GFSK":4 },
      reduce_knock:   { "AR6200":3, "AR6400-G":4, "AR9100":0, "GFSK":4 },
      reduce_smoke:   { "AR6200":2, "AR6400-G":3, "AR9100":0, "GFSK":2 }
    },
    g5_use: {
      never:       { "AR6200":1, "AR6400-G":4, "AR9100":1, "GFSK":5 },
      occasionally:{ "AR6200":2, "AR6400-G":3, "AR9100":1, "GFSK":5 },
      regularly:   { "AR6200":4, "AR6400-G":1, "GFSK":5 }
    },
    g6_multi: { yes:{}, no:{} }
  };

  /* ----------------------------------- CSS ----------------------------------- */
  var css =
':root{--aq-orange:#ff6b00;--aq-gray:#e6e6e6;--aq-speed:320ms}#archoil-quiz-root{min-height:120px}'+
'.aq-full{min-height:calc(var(--vh,1vh)*100);display:grid;grid-template-columns:1fr 1fr;background:#fff}'+
'.aq-hero{position:relative;background:#f3f4f6 center/cover no-repeat;min-height:calc(var(--vh,1vh)*100)}'+
'.aq-hero::after{content:"";position:absolute;inset:0;background:linear-gradient(90deg,rgba(0,0,0,.25) 0%,rgba(0,0,0,0) 35%)}'+
'.aq-hero.fade-in{animation:aqFadeIn var(--aq-speed) ease both}'+
'.aq-hero.fade-out{animation:aqFadeOut var(--aq-speed) ease both}'+
'.aq-panel{position:relative;background:#fff;display:flex;flex-direction:column;min-height:calc(var(--vh,1vh)*100);padding:24px 28px 28px;overflow:hidden}'+
'.aq-panel-body{position:relative;flex:1;overflow:auto;padding:0 8px 8px}'+
'.aq-enter-up{animation:aqEnterUp var(--aq-speed) ease both}'+
'.aq-enter-down{animation:aqEnterDown var(--aq-speed) ease both}'+
'.aq-leave-up{animation:aqLeaveUp var(--aq-speed) ease both}'+
'.aq-leave-down{animation:aqLeaveDown var(--aq-speed) ease both}'+
'.aq-meta{display:flex;align-items:center;justify-content:space-between;margin:0 0 6px 0;color:#6b7280;font-size:14px}'+
'.aq-progress .track{height:8px;background:#eee;border-radius:8px;overflow:hidden}'+
'.aq-progress .fill{height:100%;background:var(--aq-orange);width:0;transition:width .25s ease}'+
'.aq-stage{margin-top:16px}'+
'.aq-h2{font-weight:800;letter-spacing:-.01em;margin:0 0 16px 0;font-size:28px;line-height:1.18}'+
'@media(min-width:1100px){.aq-h2{font-size:32px}}'+
'@media(max-width:990px){.aq-h2.aq-center{text-align:center}.aq-stage .aq-subtle{font-size:16px}}'+
'.aq-options{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:16px}'+
'@media(min-width:1050px){.aq-options{grid-template-columns:repeat(4,minmax(0,1fr));gap:20px}}'+
'.aq-option{position:relative;border:0;border-radius:0;overflow:hidden;background:#fff;transition:box-shadow .2s,border-color .2s}'+
'.aq-option:hover{box-shadow:none}'+
'.aq-option.selected{outline:none}'+
'.aq-option .half-top{display:flex;align-items:center;justify-content:center;background:#f3f4f6;aspect-ratio:1/1}'+
'.aq-icon{width:62%;height:62%;object-fit:contain;display:block}'+
'.aq-initial{width:64px;height:64px;border-radius:999px;background:#ffe8d8;color:#7c2d12;display:flex;align-items:center;justify-content:center;font-weight:900;font-size:22px}'+
'.aq-option .half-bottom{display:flex;align-items:center;justify-content:center;padding:16px 16px;box-sizing:border-box;font-weight:800;font-size:17px;background:#e6e6e6;color:#000;text-align:center;height:var(--aq-label-h,96px);line-height:1.25;word-break:normal;overflow-wrap:break-word;hyphens:none}'+
'.aq-option.selected .half-bottom{background:var(--aq-orange);color:#fff}'+
'.aq-subtle{color:#6b7280;font-size:14px;margin-top:8px;text-align:center}'+
'.aq-actions{margin-top:16px;display:grid;grid-template-columns:1fr auto 1fr;align-items:center;gap:12px}'+
'.aq-btn{display:inline-flex;align-items:center;justify-content:center;border-radius:999px;padding:16px 28px;font-weight:800;cursor:pointer;border:1px solid #d1d5db;background:#fff;color:#374151}'+
'.aq-btn[disabled]{opacity:.4;cursor:not-allowed}'+
'.aq-next{justify-self:center;background:var(--aq-orange);color:#fff;border-color:transparent;font-size:18px}'+
'.aq-back{justify-self:start;background:#fff}'+
'@media(max-width:990px){.aq-stage .aq-next{width:100%}}'+
'@media(max-width:990px){.aq-full{grid-template-columns:1fr}.aq-hero{height:32vh;min-height:32vh}.aq-panel{min-height:calc(100vh - 32vh)}.aq-actions{grid-template-columns:1fr;gap:12px}.aq-actions .aq-btn{width:100%}.aq-next{order:1}.aq-back{order:2;width:100%}}'+
'.aq-results-grid{display:grid;gap:16px;margin-bottom:48px}'+
'@media(min-width:640px){.aq-results-grid{grid-template-columns:repeat(3,minmax(0,1fr))}}'+
'.aq-result{position:relative;border:1px solid #e5e7eb;border-radius:12px;overflow:hidden;background:#fff;transition:box-shadow .2s}'+
'.aq-result:hover{box-shadow:0 6px 18px rgba(0,0,0,.08)}'+
'.aq-ring{outline:2px solid #ff6b00;outline-offset:0}'+
'.aq-badge{position:absolute;top:8px;left:8px;background:rgba(0,0,0,.8);color:#fff;border-radius:999px;width:28px;height:28px;display:flex;align-items:center;justify-content:center;font-size:12px;font-weight:700}'+
'.aq-best{position:absolute;top:8px;right:8px;background:#ff6b00;color:#fff;border-radius:6px;padding:2px 6px;font-size:10px;font-weight:700}'+
'.aq-img{aspect-ratio:1/1;width:100%;object-fit:cover;background:#f3f4f6}'+
'.aq-res-body{padding:12px}'+
'.aq-chip{background:rgba(0,0,0,.8);color:#fff;border-radius:999px;padding:2px 6px;font-size:11px;font-weight:700}'+
'.aq-bar{width:100%;height:6px;background:#e5e7eb;border-radius:999px;overflow:hidden;margin:6px 0 8px}'+
'.aq-bar>div{height:100%;background:#ff6b00;width:0}'+
'.aq-row{display:flex;align-items:center;justify-content:space-between;margin-bottom:4px}'+
'.aq-retake{display:grid;grid-template-columns:1fr auto 1fr;align-items:center;gap:16px;margin-top:24px}'+
'.aq-retake .aq-btn{justify-self:start}'+
'.aq-retake .aq-next{grid-column:2;justify-self:center}'+
'@media(max-width:990px){.aq-retake{grid-template-columns:1fr;gap:12px}.aq-retake .aq-btn,.aq-retake .aq-next{width:100%;justify-self:stretch}.aq-retake .aq-next{order:1}.aq-retake .aq-btn{order:2}}'+
'.aq-why{grid-column:1/-1;width:100%;margin:12px 0 0;padding:16px 20px;border:1px solid #e5e7eb;border-radius:12px;background:#f9fafb}'+
'.aq-why h3{margin:0 0 8px;font-size:18px;font-weight:700}'+
'.aq-why .muted{color:#6b7280;font-size:16px}'+
'.aq-why .split{display:grid;gap:12px}'+
'@media(min-width:768px){.aq-why .split{grid-template-columns:1fr 2fr}}'+
'.aq-why ul{margin:8px 0 0 16px}'+
'.aq-why li{margin:6px 0}'+
'.aq-gate{max-width:36rem;margin:12px auto 0;padding:16px 20px;border:1px solid #e5e7eb;border-radius:12px;background:#fff;position:relative}'+
'.aq-gate h3{margin:0 0 8px;font-weight:800;font-size:20px}'+
'.aq-gate .sub{margin:0 0 12px;color:#374151;font-size:14px}'+
'.aq-field{margin:10px 0}'+
'.aq-label{display:block;font-size:14px;margin-bottom:6px;color:#374151;letter-spacing:.08em}'+
'.aq-input{width:100%;padding:12px 14px;border:1px solid #d1d5db;border-radius:10px;font-size:16px}'+
'.aq-help{color:#6b7280;font-size:13px;margin-top:6px}'+
'.aq-err{color:#b91c1c;font-size:13px;margin-top:6px;display:none}'+
'.aq-gate-actions{display:flex;gap:12px;margin-top:12px;align-items:center;justify-content:center}'+
'.aq-skipbtn{background:#e5e7eb;border-color:transparent;color:#111}'+
'.aq-skipbtn:hover{opacity:.95}'+
'.aq-label-row{display:flex;align-items:baseline;justify-content:space-between;gap:10px}'+
'.aq-required-pill{font-size:14px;letter-spacing:.08em;color:#374151;opacity:.8}'+
'@media(max-width:640px){.aq-required-pill{font-size:13px}}'+
'@media(max-width:640px){.aq-gate-actions{display:grid;grid-template-columns:1fr;gap:12px}.aq-gate-actions .aq-btn{width:100%}}'+
'@media(max-width:990px){.aq-gate-actions{display:grid;grid-template-columns:1fr;gap:12px}.aq-gate-actions .aq-btn{width:100%}.aq-gate-actions .aq-next{order:1}.aq-gate-actions .aq-skipbtn{order:2}}'+
'@media(min-width:990px){.aq-panel-body.aq-intro{display:grid;place-items:center;padding:0 40px}.aq-intro .aq-stage{max-width:560px;margin:0 auto;display:grid;gap:12px;text-align:center}.aq-intro .aq-stage .aq-btn{width:100%}.aq-intro .aq-h2{font-size:42px;line-height:1.1;margin-bottom:14px}.aq-intro .aq-subtle{font-size:18px;line-height:1.6;color:#4b5563;margin:8px 0 10px}}'+
'@media(max-width:990px){#archoil-quiz-root .aq-retake{grid-template-columns:1fr !important; gap:12px !important}#archoil-quiz-root .aq-retake .aq-btn, #archoil-quiz-root .aq-retake .aq-next{width:100% !important; justify-self:stretch !important}#archoil-quiz-root .aq-retake .aq-next{order:1 !important}#archoil-quiz-root .aq-retake .aq-btn{order:2 !important}}'+
'.aq-retake{display:grid;grid-template-columns:1fr auto 1fr;align-items:center;gap:16px;margin-top:24px}'+
'.aq-retake .aq-btn{justify-self:start}'+
'.aq-retake .aq-next{grid-column:2;justify-self:center}'+
'@media(max-width:990px){#archoil-quiz-root .aq-retake{grid-template-columns:1fr !important;gap:12px !important}#archoil-quiz-root .aq-retake .aq-btn, #archoil-quiz-root .aq-retake .aq-next{width:100% !important;justify-self:stretch !important}#archoil-quiz-root .aq-retake .aq-next{order:1 !important;grid-column:auto !important}#archoil-quiz-root .aq-retake .aq-btn{order:2 !important;grid-column:auto !important}}'+
'@media(max-width:990px){#archoil-quiz-root .aq-retake{grid-template-columns:1fr !important; gap:12px !important}#archoil-quiz-root .aq-retake > *{width:100% !important; justify-self:stretch !important; grid-column:auto !important}#archoil-quiz-root .aq-retake a.aq-next{order:1 !important}#archoil-quiz-root .aq-retake .aq-next{order:1 !important}#archoil-quiz-root .aq-retake .aq-btn:not(.aq-next){order:2 !important}}'+
'@media(min-width:990px){#archoil-quiz-root .aq-actions{grid-template-columns:1fr; gap:14px}#archoil-quiz-root .aq-actions .aq-btn{width:100%; justify-self:stretch}#archoil-quiz-root .aq-actions .aq-next{order:1}#archoil-quiz-root .aq-actions .aq-back{order:2}}'+
'@media(min-width:990px){#archoil-quiz-root .aq-retake{grid-template-columns:1fr; gap:14px}#archoil-quiz-root .aq-retake > *{width:100%; justify-self:stretch; grid-column:auto}#archoil-quiz-root .aq-retake .aq-next{order:1}#archoil-quiz-root .aq-retake .aq-btn:not(.aq-next){order:2}}'+
'@media(min-width:990px){#archoil-quiz-root .aq-gate-actions{display:grid; grid-template-columns:1fr; gap:14px}#archoil-quiz-root .aq-gate-actions .aq-btn{width:100%}#archoil-quiz-root .aq-gate-actions .aq-next{order:1}#archoil-quiz-root .aq-gate-actions .aq-skipbtn{order:2}}'+
'@media(max-width:990px){.aq-stage .aq-restore{width:100%; font-size:15px; padding:14px 20px}}'+
'.aq-popup-msg{margin:8px 0 10px;padding:10px 12px;border:2px solid var(--aq-orange);border-radius:12px;background:rgba(255,255,255,0.95);color:#111;font-weight:800;font-size:18px;line-height:1.35;box-shadow:0 0 0 3px rgba(255,107,0,0.12), 0 8px 24px rgba(255,107,0,0.12)}'+
'@media(min-width:990px){.aq-popup-msg{font-size:18px;padding:12px 14px}}'+
'.aq-progress{position:relative}'+
'.aq-tenoff{position:absolute;right:0;bottom:-18px;font-weight:900;color:var(--aq-orange);font-size:14px;letter-spacing:.02em}'+
'.aq-sms-consent{font-size:10px;line-height:1;letter-spacing:0 !important;text-transform:none !important;font-weight:500;color:#374151;}'+
'.aq-sms-consent a{color:inherit;text-decoration:underline;}'+
'.aq-sms-consent{font-size:10px;line-height:1;letter-spacing:0 !important;text-transform:none !important;font-weight:500;color:#374151;}'+
'.aq-sms-consent a{color:inherit;text-decoration:underline;}'+
'#archoil-quiz-root .aq-sms-consent input[type="checkbox"]{'+
'  width:20px;height:20px;min-width:20px;min-height:20px;'+
'  transform:scale(1);'+
'  accent-color:var(--aq-orange);'+
'  flex:0 0 auto;'+
'}'+
'@media(max-width:990px){'+
'  #archoil-quiz-root .aq-sms-consent input[type="checkbox"]{width:24px;height:24px;min-width:24px;min-height:24px;}'+
'  #archoil-quiz-root .aq-sms-consent{font-size:12px;line-height:1.3;}'+
'}'+

'@media(min-width:990px){.aq-tenoff{bottom:-20px;font-size:15px}}'+
'.aq-gate-badge{display:inline-block;background:var(--aq-orange);color:#fff;font-weight:800;font-size:13px;line-height:1.3;letter-spacing:.04em;border-radius:6px;padding:4px 9px;margin-bottom:10px}'+
'.aq-optbox{margin:12px 0 4px;padding:10px 12px 12px;border:1px dashed #d1d5db;border-radius:10px;background:#f9fafb;text-align:left}'+
'.aq-optbox-row{display:flex;justify-content:space-between;align-items:baseline;gap:10px;margin-bottom:8px;font-size:14px;line-height:1.35;color:#374151}'+
'.aq-optbox-row strong{font-weight:600;color:#111;white-space:nowrap}'+
'#archoil-quiz-root .aq-optbox .aq-sms-consent{margin-bottom:8px}'+
'.aq-opt-tag{flex:none;font-weight:600;font-size:11px;letter-spacing:.1em;text-transform:uppercase;color:#6b7280;border:1px solid #d1d5db;border-radius:4px;padding:1px 6px;background:#fff}'+
'#archoil-quiz-root .aq-optbox .aq-input{padding:9px 12px;background:#fff;box-sizing:border-box}'+
'#archoil-quiz-root .aq-skiplink{display:block;width:100%;margin:6px 0 0;padding:10px 6px;background:none;border:0;box-shadow:none;min-height:0;font:inherit;font-size:15px;font-weight:500;line-height:1.35;color:#6b7280;text-decoration:underline;text-align:center;cursor:pointer}'+
'#archoil-quiz-root .aq-skiplink:hover{color:#374151}'+
'#archoil-quiz-root .aq-intro .aq-next{background:#BC1C02 !important;border-color:#BC1C02 !important}'+
'#archoil-quiz-root .aq-intro .aq-next:hover{filter:brightness(0.95)}'+
'@keyframes aqFadeIn{from{opacity:0}to{opacity:1}}'+
'@keyframes aqFadeOut{from{opacity:1}to{opacity:0}}'+
'@keyframes aqEnterUp{from{opacity:.0;transform:translateY(28px)}to{opacity:1;transform:translateY(0)}}'+
'@keyframes aqLeaveUp{from{opacity:1;transform:translateY(0)}to{opacity:.0;transform:translateY(-28px)}}'+
'@keyframes aqEnterDown{from{opacity:.0;transform:translateY(-28px)}to{opacity:1;transform:translateY(0)}}'+
'@keyframes aqLeaveDown{from{opacity:1;transform:translateY(0)}to{opacity:.0;transform:translateY(28px)}}';

  function injectStyles(){
    if(document.getElementById('archoil-quiz-styles')) return;
    var s=document.createElement('style'); s.id='archoil-quiz-styles'; s.innerHTML=css; document.head.appendChild(s);
  }

  // cleaned up: well-formed overrides
  function injectGridLayoutOverrides(){
    if (document.getElementById('aq-grid-overrides')) return;
    var s = document.createElement('style');
    s.id = 'aq-grid-overrides';
    s.textContent = `
      #archoil-quiz-root .aq-options{
        display:grid !important;
        grid-template-columns:repeat(2,minmax(0,1fr)) !important;
        gap:16px !important;
        align-items:start; justify-items:stretch;
      }
      @media (min-width: 900px){
        #archoil-quiz-root .aq-options{
          grid-template-columns:repeat(4,minmax(0,1fr)) !important;
          gap:20px !important;
        }
      }
      #archoil-quiz-root .aq-option{
        border:0 !important; border-radius:0 !important; box-shadow:none !important; overflow:hidden !important; background:#fff !important;
      }
      #archoil-quiz-root .aq-option .half-top{ aspect-ratio:1/1 !important; background:#f3f4f6 !important; }
      #archoil-quiz-root .aq-icon{ width:62% !important; height:62% !important; object-fit:contain !important; display:block !important; }
      #archoil-quiz-root .aq-option .half-bottom{
        height:var(--aq-label-h,96px) !important;
        font-size:17px !important;
        line-height:1.25 !important;
        padding:16px 16px !important;
        box-sizing:border-box !important;
        word-break:normal !important;
        overflow-wrap:break-word !important;
        hyphens:none !important;
      }
      @media (max-width: 640px){
        #archoil-quiz-root .aq-option .half-bottom{
          height:var(--aq-label-h,112px) !important;
          font-size:16px !important;
          padding:18px 16px !important;
          box-sizing:border-box !important;
          word-break:normal !important;
          overflow-wrap:break-word !important;
          hyphens:none !important;
        }
      }
      #archoil-quiz-root .aq-option.selected .half-bottom{ background:var(--aq-orange) !important; color:#fff !important; }
    `;
    document.head.appendChild(s);
  }

  /* ------------------------------ logic helpers ------------------------------ */
  function shouldShowQuestion(q,a){
    if(!q.show_when) return true;
    for(var key in q.show_when){ var allowed=q.show_when[key]; if(!allowed.includes(a[key])) return false; }
    return true;
  }
  function makeCond(expr){
    var t=String(expr||'').match(/\(|\)|AND|OR|!=|=|[a-zA-Z0-9_\-]+/g)||[], i=0;
    function atom(){ if(t[i]==='('){ i++; var n=disj(); if(t[i]===')') i++; return n; }
      if(i+2<t.length){ var f=t[i++],op=t[i++],v=t[i++]; if(op==='=')return function(a){return String(a[f])===v;}; if(op==='!=')return function(a){return String(a[f])!==v;}; }
      return function(){return false;}; }
    function conj(){ var l=atom(); while(t[i]==='AND'){ i++; var r=atom(); (function(R){var P=l;l=function(a){return P(a)&&R(a);};})(r);} return l; }
    function disj(){ var l=conj(); while(t[i]==='OR'){ i++; var r=conj(); (function(R){var P=l;l=function(a){return P(a)||R(a);};})(r);} return l; }
    return t.length?disj():function(){return false;};
  }

  function scoreWithMatrix(a){
    var ids=CONFIG.products.map(function(p){return p.id;});
    var scores={}; ids.forEach(function(id){scores[id]=0;});

    function addRel(qid,val,multi){
      if(!REL[qid]) return;
      if(multi && Array.isArray(val)){
        val.forEach(function(v){ if(REL[qid][v]) for(var pid in REL[qid][v]) scores[pid]+=Number(REL[qid][v][pid]||0); });
      }else if(REL[qid][val]){
        for(var pid in REL[qid][val]) scores[pid]+=Number(REL[qid][val][pid]||0);
      }
    }

    addRel('q1_engine',a.q1_engine);
    if(a.q1_engine==='diesel'){
      addRel('d2_vehicle',a.d2_vehicle);
      addRel('d3_miles',a.d3_miles);
      addRel('d4_benefits',a.d4_benefits,true);
      addRel('d5_use',a.d5_use);
      addRel('d6_cold',a.d6_cold);
      addRel('d7_multi',a.d7_multi);
    }else if(a.q1_engine==='gasoline'){
      addRel('g2_vehicle',a.g2_vehicle);
      addRel('g3_miles',a.g3_miles);
      addRel('g4_benefits',a.g4_benefits,true);
      addRel('g5_use',a.g5_use);
      addRel('g6_multi',a.g6_multi);
    }

    CONFIG.exclusions.forEach(function(ex){
      if(makeCond(ex.condition)(a)) scores[ex.exclude_product_id]=-1e9;
    });

    // Mutual exclusion policy: AR6500 vs AR6300
    if (a.q1_engine === 'diesel') {
      var coldYes = (a.d6_cold === 'yes');
      var wantsAG = Array.isArray(a.d4_benefits) && a.d4_benefits.indexOf('anti_gel') > -1;
      var eligibleSometimes = (a.d6_cold === 'sometimes') && (isWinterMonth() || wantsAG);

      if (coldYes || eligibleSometimes) {
        // winter → never show AR6500
        scores['AR6500'] = -1e9;
      } else {
        // non-winter → never show AR6300
        scores['AR6300'] = -1e9;
      }
    }

    var maxScore = Math.max.apply(null, ids.map(function(id){ return scores[id]; }));
    var preferredKit = (a.q1_engine==='diesel') ? 'DFSK' : (a.q1_engine==='gasoline' ? 'GFSK' : null);

    var ranked = ids.sort(function(aid,bid){
      var diff = (scores[bid]||0) - (scores[aid]||0);
      if(diff!==0) return diff;
      if(preferredKit && scores[aid]===maxScore && scores[bid]===maxScore){
        if(aid===preferredKit && bid!==preferredKit) return -1;
        if(bid===preferredKit && aid!==preferredKit) return 1;
      }
      return 0;
    });

    return {scores:scores, ranked:ranked};
  }

  /* ---------- helper: benefit → top-3 props ----------------------- */
  function buildBenefitProps(a){
    var isDiesel = a.q1_engine === 'diesel';
    var benefitIds = (isDiesel ? a.d4_benefits : a.g4_benefits) || [];
    var qid = isDiesel ? 'd4_benefits' : 'g4_benefits';
    var labels = benefitIds.map(function(id){ return getOptionLabel(qid, id); })
                           .filter(Boolean)
                           .slice(0, 3);
    var props = {};
    if (labels.length) props.quiz_benefits  = labels.join(', ');
    if (labels[0])     props.quiz_benefit_1 = labels[0];
    if (labels[1])     props.quiz_benefit_2 = labels[1];
    if (labels[2])     props.quiz_benefit_3 = labels[2];
    return props;
  }

  /* ------------------------ explanation helpers --------------------- */
  function getOptionLabel(qid, oid){
    for(var i=0;i<CONFIG.options.length;i++){
      var o = CONFIG.options[i];
      if(o.question_id===qid && o.option_id===oid) return o.label||oid;
    }
    return oid;
  }
  function summarizeAnswers(a){
    var out=[];
    if(a.q1_engine){ out.push('Engine: '+ getOptionLabel('q1_engine', a.q1_engine)); }
    if(a.q1_engine==='diesel'){
      if(a.d2_vehicle) out.push('Vehicle: '+ getOptionLabel('d2_vehicle', a.d2_vehicle));
      if(a.d3_miles)   out.push('Miles: '+ getOptionLabel('d3_miles', a.d3_miles));
      if(a.d4_benefits && a.d4_benefits.length) out.push('Top benefits: '+ a.d4_benefits.map(function(x){return getOptionLabel('d4_benefits',x);}).join(', '));
      if(a.d5_use)     out.push('Usage: '+ getOptionLabel('d5_use', a.d5_use));
      if(a.d6_cold)    out.push('Climate: '+ getOptionLabel('d6_cold', a.d6_cold));
      if(a.d7_multi)   out.push('Multiple vehicles: '+ getOptionLabel('d7_multi', a.d7_multi));
    }else if(a.q1_engine==='gasoline'){
      if(a.g2_vehicle) out.push('Vehicle: '+ getOptionLabel('g2_vehicle', a.g2_vehicle));
      if(a.g3_miles)   out.push('Miles: '+ getOptionLabel('g3_miles', a.g3_miles));
      if(a.g4_benefits && a.g4_benefits.length) out.push('Top benefits: '+ a.g4_benefits.map(function(x){return getOptionLabel('g4_benefits',x);}).join(', '));
      if(a.g5_use)     out.push('Usage: '+ getOptionLabel('g5_use', a.g5_use));
      if(a.g6_multi)   out.push('Multiple vehicles: '+ getOptionLabel('g6_multi', a.g6_multi));
    }
    return out;
  }
  function buildReasonsForProduct(p, a){
    var id = p.id, reasons = [];
    var diesel = a.q1_engine==='diesel', gas = a.q1_engine==='gasoline';
    var benefits = (diesel ? a.d4_benefits : a.g4_benefits) || [];
    var wantsAG = benefits.indexOf('anti_gel')>-1;
    var wantsMPG = benefits.indexOf('improved_mpg')>-1;
    var wantsPower = benefits.indexOf('power_response')>-1;
    var wantsSmoke = benefits.indexOf('reduce_smoke')>-1;
    var reduceKnock = benefits.indexOf('reduce_knock')>-1;
    var olderVeh = diesel ? a.d2_vehicle==='older_diesel' : a.g2_vehicle==='older_gas';
    var highMiles = (diesel ? a.d3_miles : a.g3_miles)==='100k_plus';
    var rarely = (diesel ? a.d5_use : a.g5_use)==='never';
    var sometimesCold = a.d6_cold==='sometimes';
    var cold = a.d6_cold==='yes';
    var coldScenario = isColdScenario(a);

    if(id==='AR6300'){
      if(cold) reasons.push('You drive in cold weather; AR6300 adds anti-gel winter protection.');
      if(sometimesCold && isWinterMonth()) reasons.push('It’s winter in your climate; anti-gel protection is appropriate.');
      if(wantsAG) reasons.push('You selected “Anti-gel protection” as a priority.');
    }
    if(id==='AR6500'){
      if(wantsMPG||wantsPower) reasons.push('You wanted better MPG/power; AR6500 boosts cetane and lubricity for ongoing gains.');
    }
    if(id==='AR6400-D'){
      if(olderVeh||highMiles) reasons.push('Older/high-mileage diesel benefits from a strong one-tank clean.');
      if(rarely) reasons.push('You don’t treat often; a rapid deep clean helps revive injectors and the fuel system.');
      if(wantsPower||wantsSmoke) reasons.push('Deep cleaning injectors helps restore response and reduce smoke.');
    }
    if(id==='DFSK'){
      reasons.push('This kit combines AR6400-D for a rapid deep clean and AR6500 for ongoing gains at every fill-up.');
      if(olderVeh||highMiles||rarely) reasons.push('Two-step restore is ideal for older/high-mileage or rarely treated systems.');
    }
    if(id==='UDK'){
      reasons.push('This kit combines AR6400-D for a rapid deep clean, AR6500 for ongoing gains at every fill-up + AR9100 to upgrade your oil at every oil change and to eliminate stiction in 6.0L and 7.3L Power Stroke engines.');
      if(a.d2_vehicle==='powerstroke_6_0_7_3') reasons.push('You indicated a 6.0/7.3L Power Stroke; AR9100 targets HEUI stiction.');
      if(benefits.indexOf('stiction')>-1) reasons.push('You selected “Stiction fix”; AR9100 addresses that specifically.');
    }
    if(id==='WDFK'){
      reasons.push('This kit combines AR6400-D for a rapid deep clean, and AR6300 for ongoing gains and anti-gel protection at every fill-up.');
      if(a.d6_cold === 'yes') reasons.push('You drive in cold weather; kit ensures cold starts & flow.');
      if(a.d6_cold === 'sometimes' && isWinterMonth()) reasons.push('It’s winter and you sometimes see freezing temps.');
      if(wantsAG) reasons.push('You prioritized anti-gel protection.');
    }
    if(id==='UWDK'){
      reasons.push('This kit combines AR6400-D for a rapid deep clean, AR6300 for ongoing gains and anti-gel protection at every fill-up + AR9100 to upgrade your oil at every oil change and to eliminate stiction in 6.0L and 7.3L Power Stroke engines.');
      if(a.d2_vehicle==='powerstroke_6_0_7_3') reasons.push('6.0/7.3L Power Stroke benefit from AR9100.');
      if(benefits.indexOf('stiction')>-1) reasons.push('You chose “Stiction fix”.');
      if(coldScenario) reasons.push('Optimized for cold climates with anti-gel.');
    }
    if(id==='AR6200'){ if(wantsMPG) reasons.push('Simple every-fill MPG helper.'); }
    if(id==='AR6400-G'){
      if(olderVeh||highMiles) reasons.push('One-tank clean for older/high-mileage gas engines.');
      if(reduceKnock||wantsPower) reasons.push('Cleaning helps reduce knock and restore response.');
    }
    if(id==='GFSK'){ reasons.push('AR6400-G deep clean + AR6200 ongoing fuel quality.'); }

    if(!reasons.length){
      if(diesel) reasons.push('Matches your diesel answers across vehicle, mileage and priorities.');
      if(gas)    reasons.push('Matches your gasoline answers across vehicle, mileage and priorities.');
    }
    return reasons.slice(0,4);
  }
  function buildWhyElement(bestProduct, answers){
    var box = el('div',{class:'aq-why'},[]);
    box.appendChild(el('h3',{},['Why we picked ', bestProduct.name]));
    var split = el('div',{class:'split'},[]);

    var left = el('div',{},[]);
    left.appendChild(el('div',{class:'muted'},['What you told us']));
    var ulL = el('ul',{},[]); summarizeAnswers(answers).forEach(function(line){ ulL.appendChild(el('li',{},[line])); });
    left.appendChild(ulL);

    var right = el('div',{},[]);
    right.appendChild(el('div',{class:'muted'},['How this product fits your answers']));
    var ulR = el('ul',{},[]); buildReasonsForProduct(bestProduct, answers).forEach(function(r){ ulR.appendChild(el('li',{},[r])); });
    right.appendChild(ulR);

    split.appendChild(left); split.appendChild(right);
    box.appendChild(split);
    return box;
  }
  function findProduct(id){ return CONFIG.products.find(function(p){ return p.id===id; }); }

  // The WDFK product has a new public name, but its historical reporting name stays
  // stable for Klaviyo, Attentive, and Shopify newsletter-tag analytics.
  function aqProductReportingName(p){
    return p ? (p.reporting_name || p.name || p.id || '') : '';
  }

  /* ---------------- Shopify Ajax product data for result cards ----------------
     Prices and featured images are read from Shopify when a result is displayed.
     Product URLs with ?variant= use that exact variant. This is particularly
     important for GFSK and UWDK, which are variants of another parent product.
     Requests are cached only for the current page load, not across visits.
     No admin tokens or customer details are needed.
  ----------------------------------------------------------------------------- */
  var aqShopifyCatalogRequests = Object.create(null);

  function aqShopifyImageUrl(value){
    var url = (typeof value === 'string') ? value : (value && (value.src || value.url));
    if (!url || typeof url !== 'string') return '';
    if (url.indexOf('//') === 0) return window.location.protocol + url;
    if (url.charAt(0) === '/') return window.location.origin + url;
    return /^https?:\/\//i.test(url) ? url : '';
  }

  function aqShopifyFormatPrice(cents){
    var value = Number(cents);
    if (!Number.isFinite(value)) return '';
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat('en-US', {style:'currency', currency:currency}).format(value / 100);
    } catch (_) {
      return '$' + (value / 100).toFixed(2);
    }
  }

  function aqLoadShopifyProductCardData(item){
    var productUrl;
    try { productUrl = new URL(item.url, window.location.origin); }
    catch (_) { return Promise.reject(new Error('Invalid product URL: ' + item.id)); }

    var match = productUrl.pathname.match(/\/products\/([^/]+)/);
    if (!match) return Promise.reject(new Error('No Shopify product handle: ' + item.id));

    // Shopify recommends locale-aware same-origin Ajax paths.
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    root = '/' + String(root).replace(/^\/+|\/+$/g, '') + '/';
    if (root === '//') root = '/';
    var endpoint = root + 'products/' + encodeURIComponent(decodeURIComponent(match[1])) + '.js';

    if (!aqShopifyCatalogRequests[endpoint]) {
      aqShopifyCatalogRequests[endpoint] = fetch(endpoint, {
        method: 'GET', credentials: 'same-origin', headers: {'Accept':'application/json'}
      }).then(function(res){
        if (!res.ok) throw new Error('Shopify returned HTTP ' + res.status + ' for ' + endpoint);
        return res.json();
      });
    }

    return aqShopifyCatalogRequests[endpoint].then(function(product){
      var variants = Array.isArray(product.variants) ? product.variants : [];
      var requestedVariantId = productUrl.searchParams.get('variant');
      var variant = requestedVariantId
        ? variants.find(function(v){return String(v.id) === requestedVariantId;})
        : (variants.find(function(v){return v.available;}) || variants[0]);

      // Never use the AR6200/AR6300 base price for one of their kit variants.
      if (requestedVariantId && !variant) {
        throw new Error('Variant ' + requestedVariantId + ' not found for ' + item.id);
      }

      var cents = variant && variant.price != null ? variant.price : (!requestedVariantId ? product.price : null);
      var price = aqShopifyFormatPrice(cents);
      if (!price) throw new Error('Price unavailable for ' + item.id);

      // A variant's own Shopify image is preferred. For variant-based kits,
      // never substitute the base product's photo: retain the current kit photo
      // if Shopify has not assigned a featured image to that variant.
      var variantImage = variant && (variant.featured_image ||
        (variant.featured_media && (variant.featured_media.preview_image || variant.featured_media)));
      var image = aqShopifyImageUrl(variantImage);
      if (!image && !requestedVariantId) {
        image = aqShopifyImageUrl(product.featured_image || (product.images && product.images[0]));
      }
      return {price:price, image:image};
    });
  }

  function aqUpdateResultCardFromShopify(item, imageEl, priceEl){
    aqLoadShopifyProductCardData(item).then(function(data){
      // The visitor might have retaken the quiz before Shopify responds.
      if (!priceEl || !priceEl.isConnected) return;
      priceEl.textContent = data.price;
      if (imageEl && data.image && imageEl.isConnected) imageEl.src = data.image;
    }).catch(function(err){
      // Don't present a potentially stale hardcoded price as the real price.
      if (priceEl && priceEl.isConnected) priceEl.textContent = 'View current price';
      if (window.console && console.warn) console.warn('[Find Your Formula] Shopify product lookup:', item.id, err);
    });
  }


  function trackGA4(eventName, params){
  try{
    if (typeof window.gtag !== 'function') return;
    var payload = Object.assign({ }, params || {});
    // Optional: makes it show up in DebugView when you're testing
    // payload.debug_mode = true;

    window.gtag('event', eventName, payload);
  }catch(_){}
}


  /* -------------------- Klaviyo basic tracking ---------------------- */
  function trackKlaviyo(eventName, props){
    try {
      window._learnq = window._learnq || [];
      var payload = props || {};
      if (window.klaviyo && typeof window.klaviyo.track === 'function') {
        window.klaviyo.track(eventName, payload);
        return;
      }
      window._learnq.push(['track', eventName, payload]);
    } catch(_) {}
  }
  function aqRunId(){
    try{
      var id = sessionStorage.getItem('aq_run_id');
      if(!id){ id = Date.now().toString(36) + Math.random().toString(36).slice(2,8); sessionStorage.setItem('aq_run_id', id); }
      return id;
    }catch(_){ return String(Date.now()); }
  }

  /* -------------------- Drop-off tracking (v2.0) --------------------
     One event per screen, sent once per quiz run (Back/Next does not send it again; Retake starts a new run).
       Klaviyo: one metric per screen, e.g. "Archoil Quiz Step: Diesel Q3 Miles"
       GA4:     one event, archoil_quiz_step, with step_id / step_name / step_number
     People who left on a screen = that screen's count minus the next screen's count. */
  var AQ_STEP_NAMES = {
    q1_engine:   'Q1 Engine',
    d2_vehicle:  'Diesel Q2 Vehicle',
    d3_miles:    'Diesel Q3 Miles',
    d4_benefits: 'Diesel Q4 Benefits',
    d5_use:      'Diesel Q5 Use',
    d6_cold:     'Diesel Q6 Cold',
    d7_multi:    'Diesel Q7 Multi',
    g2_vehicle:  'Gas Q2 Vehicle',
    g3_miles:    'Gas Q3 Miles',
    g4_benefits: 'Gas Q4 Benefits',
    g5_use:      'Gas Q5 Use',
    g6_multi:    'Gas Q6 Multi'
  };
  var __aq_once_mem = {};
  function aqOncePerRun(key){
    var k = 'aq_once_' + aqRunId() + '_' + key;
    if (__aq_once_mem[k]) return false;
    __aq_once_mem[k] = true;
    try{
      if (sessionStorage.getItem(k) === '1') return false;
      sessionStorage.setItem(k, '1');
    }catch(_){}
    return true;
  }
  function aqEngineLabel(){
    try{ var a = state.answers || {}; return a.q1_engine ? getOptionLabel('q1_engine', a.q1_engine) : ''; }catch(_){ return ''; }
  }
  function trackQuizViewed(){
    try{
      try{
        if (sessionStorage.getItem('aq_viewed_sent') === '1') return;
        sessionStorage.setItem('aq_viewed_sent', '1');
      }catch(_){}
      var runId = aqRunId(), src = getEntrySource();
      trackKlaviyo('Archoil Quiz Viewed', { quiz_run_id: runId, entry_source: src, viewed_at: new Date().toISOString() });
      trackGA4('archoil_quiz_viewed', { quiz_run_id: runId, entry_source: src });
    }catch(_){}
  }
  function trackQuizStep(q){
    try{
      if (!q || !q.id) return;
      if (!aqOncePerRun('step_' + q.id)) return;
      var name = AQ_STEP_NAMES[q.id] || q.id;
      var num = parseInt(String(q.id).replace(/\D/g, ''), 10) || 0;
      var runId = aqRunId(), src = getEntrySource(), engine = aqEngineLabel();
      trackKlaviyo('Archoil Quiz Step: ' + name, {
        quiz_run_id: runId, step_id: q.id, step_number: num, quiz_engine: engine, entry_source: src
      });
      trackGA4('archoil_quiz_step', {
        quiz_run_id: runId, step_id: q.id, step_name: name, step_number: num, quiz_engine: engine, entry_source: src
      });
    }catch(_){}
  }
  function trackQuizGateViewed(){
    try{
      if (!aqOncePerRun('step_gate')) return;
      var a = state.answers || {};
      var total = (a.q1_engine === 'diesel') ? 7 : (a.q1_engine === 'gasoline' ? 6 : 0);
      var runId = aqRunId(), src = getEntrySource(), engine = aqEngineLabel();
      var via = window.__aq_restored ? 'return_to_results' : 'quiz';
      trackKlaviyo('Archoil Quiz Step: Email', {
        quiz_run_id: runId, step_id: 'gate', step_number: total + 1, quiz_engine: engine, entry_source: src, via: via
      });
      trackGA4('archoil_quiz_step', {
        quiz_run_id: runId, step_id: 'gate', step_name: 'Email', step_number: total + 1, quiz_engine: engine, entry_source: src, via: via
      });
    }catch(_){}
  }

  /* -------------------- Meta Pixel: standard Lead (v2.0) --------------------
     Sent when the email step accepts an email. Once per browser session.
     The key matches the one used by the earlier Lead script in sections/archoil-quiz.liquid,
     so if both are installed only one Lead is sent. */
  var __aq_lead_sent = false;
  function aqTrackMetaLead(){
    try{
      if (__aq_lead_sent) return;
      __aq_lead_sent = true;
      try{
        if (sessionStorage.getItem('ao_quiz_lead_sent') === '1') return;
        sessionStorage.setItem('ao_quiz_lead_sent', '1');
      }catch(_){}
      var tries = 0;
      (function go(){
        if (typeof window.fbq === 'function') window.fbq('track', 'Lead', { content_name: 'Product Match Quiz' });
        else if (tries++ < 40) setTimeout(go, 250);   // pixel not loaded yet: wait up to 10 seconds
      })();
    }catch(_){}
  }

  /* ----------------------- Gate: subscribe helpers ------------------ */
  function parseName(fullName){
    var first='', last='';
    if(fullName){ var parts = String(fullName).trim().split(/\s+/); first = parts.shift() || ''; last  = parts.join(' ') || ''; }
    return { first:first || undefined, last:last || undefined, full: fullName || undefined };
  }
  function subscribeToKlaviyo(email, fullName, profileProps){
  // Reuse your existing Worker base (same one used for Attentive)
  var base = (typeof ATTENTIVE_WORKER_BASE === 'string' && ATTENTIVE_WORKER_BASE.trim())
    ? ATTENTIVE_WORKER_BASE.trim().replace(/\/+$/, '')
    : 'https://archoi-attentive-proxy.ross-85b.workers.dev';

  if (!base) return Promise.reject(new Error('Missing Worker base URL'));

  return fetch(base + '/klaviyo/subscribe', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    keepalive: true,
    body: JSON.stringify({
      email: String(email || '').trim(),
      full_name: String(fullName || '').trim(),
      properties: profileProps || {}
    })
  }).then(function(res){
    return res.json().catch(function(){ return null; }).then(function(j){
      if (!res.ok || !j || j.ok !== true) {
        var msg = (j && j.error) ? j.error : ('HTTP ' + res.status);
        throw new Error('Worker Klaviyo subscribe failed: ' + msg);
      }
      return j;
    });
  });
}

  function isLoggedInShopify(){ try{ return !!(window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.page && ShopifyAnalytics.meta.page.customerId); }catch(_){ return false; } }
  function isKlaviyoIdentified(){ try{ return document.cookie.indexOf('__kla_id=')>-1; }catch(_){ return false; } }
  function subscribeViaShopify(email, fullName, tagsArr){
    try{
      var form = document.getElementById('archoil-quiz-newsletter');
      if(!form){
        var forms = Array.from(document.querySelectorAll('form[action*="/contact"]'));
        form = forms.find(function(f){
          return f.id === 'archoil-quiz-newsletter' ||
                 f.querySelector('input[name="form_type"][value="customer"]') ||
                 /newsletter/i.test(f.id||'') || /newsletter/i.test(f.className||'');
        }) || null;
      }
      if(!form) return false;

      var ft = form.querySelector('input[name="form_type"]');
      if(!ft){ ft = document.createElement('input'); ft.type='hidden'; ft.name='form_type'; form.appendChild(ft); }
      ft.value = 'customer';

      var emailInput = form.querySelector('input[name="contact[email]"], input[type="email"]');
      if (emailInput) emailInput.value = email;

      var nm = parseName(fullName);
      var nameField = form.querySelector('input[name="contact[name]"], input[name="customer[name]"]');
      var firstField = form.querySelector('input[name="contact[first_name]"], input[name="customer[first_name]"]');
      var lastField  = form.querySelector('input[name="contact[last_name]"],  input[name="customer[last_name]"]');
      if (nameField && nm.full) nameField.value = nm.full;
      if (firstField && nm.first) firstField.value = nm.first;
      if (lastField && nm.last) lastField.value = nm.last;
      if (!lastField && nm.last){
        var hiddenLast = document.createElement('input');
        hiddenLast.type='hidden'; hiddenLast.name='contact[last_name]'; hiddenLast.value = nm.last; form.appendChild(hiddenLast);
      }

      var addTags = ['newsletter','archoil-quiz']
        .concat(tagsArr||[])
        .concat(isLoggedInShopify() ? ['logged-in'] : [])
        .concat(isKlaviyoIdentified() ? ['identified-browser'] : []);
      var tagsInput = form.querySelector('input[name="contact[tags]"]');
      if (tagsInput) {
        var existing = (tagsInput.value || '').trim();
        tagsInput.value = existing ? (existing + ', ' + addTags.join(', ')) : addTags.join(', ');
      } else {
        var hiddenTags = document.createElement('input');
        hiddenTags.type='hidden'; hiddenTags.name='contact[tags]'; hiddenTags.value = addTags.join(', ');
        form.appendChild(hiddenTags);
      }

      var m1 = form.querySelector('input[name="customer[accepts_marketing]"]');
      if(!m1){ m1=document.createElement('input'); m1.type='hidden'; m1.name='customer[accepts_marketing]'; form.appendChild(m1); }
      m1.value = 'true';

      var previousStyle = form.getAttribute('style') || '';
      form.setAttribute('style', (previousStyle ? previousStyle + ';' : '') +
        'display:block !important;position:fixed !important;left:-9999px !important;top:auto !important;width:1px !important;height:1px !important;overflow:hidden !important;');

      var submitBtn = form.querySelector('button[type="submit"], input[type="submit"]');
      if (!submitBtn) { submitBtn = document.createElement('button'); submitBtn.type='submit'; submitBtn.style.display='none'; form.appendChild(submitBtn); }

      form.setAttribute('data-archoil-ignore','1');
      setTimeout(function(){
        if (typeof form.requestSubmit === 'function') form.requestSubmit(submitBtn);
        else submitBtn.click();
        setTimeout(function(){ form.setAttribute('style', previousStyle); }, 1000);
      }, 250);

      return true;
    }catch(e){ return false; }
  }

  /* ----------------------- Attentive (via Cloudflare Worker proxy) ----------------------- */
  var ATTENTIVE_WORKER_BASE = (window.ARCHOIL_ATTENTIVE_WORKER_URL || 'https://archoi-attentive-proxy.ross-85b.workers.dev').trim();
  ATTENTIVE_WORKER_BASE = ATTENTIVE_WORKER_BASE.replace(/\/+$/, '');

  // US-only E.164 normalizer (because you only want US SMS)
  // Accepts:
  //  - (###) ###-####, ###-###-####, ##########  -> +1##########
  //  - 1##########                               -> +1##########
  // Rejects anything else.
  function aqNormalizePhoneE164(raw){
    try{
      var s = String(raw || '').trim();
      if (!s) return '';

      var digits = s.replace(/\D/g,'');
      if (!digits) return '';

      // Allow 11 digits with leading 1
      if (digits.length === 11 && digits[0] === '1') digits = digits.slice(1);

      // Must be 10 digits
      if (digits.length !== 10) return '';

      // NANP rules: area code & exchange code can’t start with 0 or 1
      if (!/^[2-9]\d{2}[2-9]\d{6}$/.test(digits)) return '';

      return '+1' + digits;
    }catch(_){ return ''; }
  }

  // Formats as (###) ###-#### while typing (US)
  function aqAttachUSPhoneMask(inputEl, onChange){
    if (!inputEl) return;

    function formatNow(){
      try{
        var raw = String(inputEl.value || '');
        var digits = raw.replace(/\D/g,'');

        // drop leading country code if user typed it
        if (digits.length === 11 && digits[0] === '1') digits = digits.slice(1);

        digits = digits.slice(0, 10);

        var out = '';
        if (digits.length === 0) out = '';
        else if (digits.length < 4) out = '(' + digits;
        else if (digits.length < 7) out = '(' + digits.slice(0,3) + ') ' + digits.slice(3);
        else out = '(' + digits.slice(0,3) + ') ' + digits.slice(3,6) + '-' + digits.slice(6);

        inputEl.value = out;

        if (typeof onChange === 'function') onChange();
      }catch(_){}
    }

    inputEl.addEventListener('input', formatNow);
    inputEl.addEventListener('blur', formatNow);
    inputEl.addEventListener('paste', function(){
      setTimeout(formatNow, 0);
    });
  }

  // Calls your Cloudflare Worker, which then calls Attentive securely
  function aqAttentiveSubscribeSMS(phoneE164, email, properties){
    try{
      if (!ATTENTIVE_WORKER_BASE) return Promise.resolve({ ok:false, error:'missing_worker_url' });

      return fetch(ATTENTIVE_WORKER_BASE + '/subscribe', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        keepalive: true,
        body: JSON.stringify({
          phone: phoneE164,
          email: (email || ''),
          sms_consent: true,
          properties: properties || {}
        })
      })
      .then(function(res){
        return res.json().catch(function(){ return null; }).then(function(j){
          return {
            ok: !!(res.ok && (j == null || j.ok !== false)),
            status: res.status,
            json: j
          };
        });
      })
      .catch(function(e){
        return { ok:false, error:e };
      });

    }catch(e){
      return Promise.resolve({ ok:false, error:e });
    }
  }


function getEntrySource(){
  try{
    // explicit source set at entry
    var s = sessionStorage.getItem('aq_entry_source');
    if (s) return s;

    // fallback: if they were prefilled, treat as popup
    var prefilled = sessionStorage.getItem('aq_prefilled_engine');
    if (prefilled === 'diesel' || prefilled === 'gasoline') return 'popup';

    return 'hero';
  }catch(_){
    return 'unknown';
  }
}

    function renderInlineGate(stage){
  var card = el('div',{class:'aq-gate'},[]);
  card.appendChild(el('span',{class:'aq-gate-badge'},['10% OFF YOUR FIRST ORDER']));
  card.appendChild(el('h3',{},['Want 10% off what we recommend?']));
  card.appendChild(el('div',{class:'sub'},["Enter your email and we'll send you a 10% off code for your first order."]));

  // Name is off by default (FEATURES.gateName). Everything downstream already handles a blank name.
  var nameInput  = FEATURES.gateName ? el('input',{class:'aq-input',type:'text',placeholder:'Name', autocomplete:'name'},[]) : null;
  var email      = el('input',{class:'aq-input',type:'email',placeholder:'Email address', autocomplete:'email'},[]);
  var emailErr   = el('div',{class:'aq-err'},['Please enter a valid email.']);

  // Optional phone + SMS consent (US-only)
  var phoneInput = el('input',{
    class:'aq-input',
    type:'tel',
    inputmode:'tel',
    autocomplete:'tel',
    placeholder:'(###) ###-####'
  },[]);
  var phoneErr = el('div',{class:'aq-err'},['Please enter a valid US mobile number.']);

  // SMS consent wrapper (only shown when phone has content)
  var smsWrap = el('div',{style:'display:none;margin-top:10px;text-align:left;'},[]);
  var smsConsent = el('input',{type:'checkbox'},[]);
  var smsErr = el('div',{class:'aq-err'},['To subscribe by text, please tick the box below (or clear the mobile number).']);

  var termsLink = el('a',{
    href:'https://attnl.tv/t/8nm/r/US',
    target:'_blank',
    rel:'noopener noreferrer',
    style:'color:inherit;text-decoration:underline;'
  },['Terms']);

  var privacyLink = el('a',{
    href:'https://attnl.tv/p/8nm',
    target:'_blank',
    rel:'noopener noreferrer',
    style:'color:inherit;text-decoration:underline;'
  },['Privacy Policy']);

  var smsLabel = el('label',{
  class:'aq-sms-consent',
  style:'display:flex;gap:10px;align-items:flex-start;cursor:pointer;'
},[
    smsConsent,
    el('span',{},[
      'By submitting this form, you agree to receive recurring automated marketing text messages (e.g. AI content, cart reminders) from Archoil at the number you provide. Consent not a condition of purchase. We may share info with service providers per our Privacy Policy. Reply HELP for help & STOP to cancel. Msg frequency varies. Msg & data rates may apply. By submitting this form, you also agree to our ',
      termsLink,
      ' (incl. arbitration) & ',
      privacyLink,
      '.'
    ])
  ]);

  var smsStatus = el('div',{class:'aq-help',style:'margin-top:8px;display:none;color:#111;font-weight:700;'},['']);
smsWrap.appendChild(smsStatus);
  smsWrap.appendChild(smsLabel);
  smsWrap.appendChild(smsErr);
  smsWrap.appendChild(el('div',{
  class:'aq-help',
  style:'margin:0 0 6px 0;color:#111;font-weight:800;'},["Reply 'Y' to your opt-in text to confirm your SMS signup and receive your 10% off discount code."]));

  function updateSmsVisibility(){
  var digits = (phoneInput.value || '').replace(/\D/g,'');
if (digits.length === 11 && digits[0] === '1') digits = digits.slice(1);
var complete = (digits.length === 10);


  smsWrap.style.display = complete ? 'block' : 'none';

  // reset SMS UI when not complete
  if (!complete) {
    smsConsent.checked = false;
    smsErr.style.display = 'none';
    smsStatus.style.display = 'none';
  }

  phoneErr.style.display = 'none';
}


  // Attach mask + keep UI in sync
  aqAttachUSPhoneMask(phoneInput, updateSmsVisibility);

  // Fields
  if (nameInput) {
    card.appendChild(el('div',{class:'aq-field'},[
      el('label',{class:'aq-label aq-label-row'},[
        el('span',{},['N A M E']),
        el('span',{class:'aq-required-pill'},['Optional'])
      ]),
      nameInput
    ]));
  }

  card.appendChild(el('div',{class:'aq-field'},[
  el('label',{class:'aq-label aq-label-row'},[
    el('span',{},['E M A I L']),
    el('span',{class:'aq-required-pill'},['Required'])
  ]),
  email,
  emailErr
]));

  // Mobile: visible but clearly optional, in its own box
  card.appendChild(el('div',{class:'aq-optbox'},[
    el('div',{class:'aq-optbox-row'},[
      el('span',{},['Add mobile for ', el('strong',{},['deals by text'])]),
      el('span',{class:'aq-opt-tag'},['Optional'])
    ]),
    phoneInput,
    phoneErr,
    smsWrap
  ]));

  card.appendChild(el('div',{class:'aq-help'},[
    'By entering your email and pressing the button below, you agree to receive marketing emails from Archoil. You can unsubscribe at any time via the link in our emails.'
  ]));

  var primary = el('button',{class:'aq-btn aq-next',type:'button'},['Get 10% Off & Show My Results']);

  // Enter in the email field does the same as pressing the button
  email.addEventListener('keydown', function(e){
    if (e.key === 'Enter' || e.keyCode === 13) { e.preventDefault(); primary.click(); }
  });

  primary.addEventListener('click', async function(){
    if (primary.getAttribute('data-busy') === '1') return;   // already submitting: ignore a second press
    var em = (email.value||'').trim();
    var fullName = nameInput ? (nameInput.value||'').trim() : '';

    var okEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(em);
    if(!okEmail){ emailErr.style.display='block'; email.focus(); return; }
    emailErr.style.display='none';

    updateSmsVisibility();

    var rawPhone = (phoneInput.value || '').trim();
var digits = rawPhone.replace(/\D/g,'');
if (digits.length === 11 && digits[0] === '1') digits = digits.slice(1);
var wantsSms = (digits.length === 10);
var phoneE164 = '';

// If they started typing but didn't finish, don't silently ignore: tell them
if (digits.length > 0 && digits.length < 10) {
  phoneErr.textContent = 'Please enter a full 10-digit US number or clear the field.';
  phoneErr.style.display = 'block';
  phoneInput.focus();
  return;
}

    if (wantsSms) {
      if (!smsConsent.checked) { smsErr.style.display='block'; smsConsent.focus(); return; }
      phoneE164 = aqNormalizePhoneE164(rawPhone);
      if (!phoneE164) { phoneErr.style.display='block'; phoneInput.focus(); return; }
    }

          // Build quiz properties for tagging (Klaviyo + Attentive)
      var a = window.archoilQuizAnswers || {};
      function label(qid, oid){ try{ return getOptionLabel(qid, oid); } catch(_){ return oid||''; } }

      var isDiesel = (a.q1_engine === 'diesel');

      var engId = a.q1_engine || '';
      var eng   = engId ? label('q1_engine', engId) : '';

      var vehicleId = isDiesel ? (a.d2_vehicle || '') : (a.g2_vehicle || '');
      var vehicleQ  = isDiesel ? 'd2_vehicle' : 'g2_vehicle';
      var vehicle   = vehicleId ? label(vehicleQ, vehicleId) : '';

      var milesId = isDiesel ? (a.d3_miles || '') : (a.g3_miles || '');
      var milesQ  = isDiesel ? 'd3_miles' : 'g3_miles';
      var miles   = milesId ? label(milesQ, milesId) : '';

      var useId = isDiesel ? (a.d5_use || '') : (a.g5_use || '');
      var useQ  = isDiesel ? 'd5_use' : 'g5_use';
      var use   = useId ? label(useQ, useId) : '';

      var coldId = isDiesel ? (a.d6_cold || '') : '';
      var cold   = coldId ? label('d6_cold', coldId) : '';

      var multiId = isDiesel ? (a.d7_multi || '') : (a.g6_multi || '');
      var multiQ  = isDiesel ? 'd7_multi' : 'g6_multi';
      var multi   = multiId ? label(multiQ, multiId) : '';

      var top = window.archoilTopProductName || '';
      var benefitProps = buildBenefitProps(a);
      var nm = parseName(fullName);

      // Shared props (Klaviyo + GA4)
      var props = {
        email: em,
        first_name: nm.first,
        last_name: nm.last,
        full_name: nm.full,

        quiz_engine: eng,

        quiz_vehicle: vehicle,

        quiz_miles: miles,

        quiz_use: use,

        quiz_cold: cold,

        quiz_multi: multi,

        quiz_top_product: top,
        $source: 'Archoil Quiz',
        entry_source: getEntrySource(),
        quiz_run_id: aqRunId(),
        quiz_sms_opt_in: (wantsSms ? 'yes' : 'no')
      };

      props.utm_source   = sessionStorage.getItem('aq_utm_source') || '';
      props.utm_medium   = sessionStorage.getItem('aq_utm_medium') || '';
      props.utm_campaign = sessionStorage.getItem('aq_utm_campaign') || '';
      props.utm_content  = sessionStorage.getItem('aq_utm_content') || '';
      props.utm_term     = sessionStorage.getItem('aq_utm_term') || '';

      for (var k in benefitProps) {
        if (Object.prototype.hasOwnProperty.call(benefitProps, k)) props[k] = benefitProps[k];
      }


    // Fire Attentive SMS subscribe (non-blocking)
    if (wantsSms && phoneE164) {
              var attProps = {
          quiz_run_id: props.quiz_run_id,
          entry_source: props.entry_source,

          quiz_engine: props.quiz_engine || '',

          quiz_vehicle: props.quiz_vehicle || '',

          quiz_miles: props.quiz_miles || '',

          quiz_use: props.quiz_use || '',

          quiz_cold: props.quiz_cold || '',

          quiz_multi: props.quiz_multi || '',

          quiz_top_product: props.quiz_top_product || '',
        };

        // include benefits if present
        if (props.quiz_benefits)  attProps.quiz_benefits  = props.quiz_benefits;
        if (props.quiz_benefit_1) attProps.quiz_benefit_1 = props.quiz_benefit_1;
        if (props.quiz_benefit_2) attProps.quiz_benefit_2 = props.quiz_benefit_2;
        if (props.quiz_benefit_3) attProps.quiz_benefit_3 = props.quiz_benefit_3;


      smsStatus.style.display = 'block';
smsStatus.textContent = 'Submitting SMS signup...';

aqAttentiveSubscribeSMS(phoneE164, em, attProps).then(function(r){
  if (r && r.ok) {
    smsStatus.textContent = 'SMS submitted. Check your phone and reply “Y” to confirm.';
  } else {
    smsStatus.textContent = 'SMS could not be submitted. Please double-check your US number and try again.';
    console.warn('[Archoil Quiz] Attentive SMS subscribe failed:', r);
  }
});

    }

    // Email accepted: lock the button (stops a double submit) and send the Meta Lead event
    primary.setAttribute('data-busy','1');
    primary.setAttribute('disabled','disabled');
    aqTrackMetaLead();

    // Email subscribe (Klaviyo)
    try {
      await subscribeToKlaviyo(em, fullName, (function(){
        var p={}; for (var k in props){ if(k!=='email'&&k!=='first_name'&&k!=='last_name'&&k!=='full_name') p[k]=props[k]; }
        return p;
      })());
    } catch(e) {
      console.warn('[Archoil Quiz] Klaviyo subscribe skipped/failed:', e && e.message ? e.message : e);
    }

    // Identify + track in Klaviyo + GA4
    try{
      if (window.klaviyo && typeof window.klaviyo.identify === 'function') {
        klaviyo.identify(props);
        if (typeof window.klaviyo.track === 'function') klaviyo.track('Archoil Quiz Submitted', props);
      } else if (window._learnq) {
        var legacy = Object.assign({}, props, { $email: props.email, $first_name: props.first_name, $last_name: props.last_name });
        _learnq.push(['identify', legacy]);
        _learnq.push(['track', 'Archoil Quiz Submitted', legacy]);
      }

      trackGA4('archoil_quiz_subscribed', {
        quiz_run_id: props.quiz_run_id,
        entry_source: props.entry_source,
        quiz_engine: props.quiz_engine,
        utm_source: props.utm_source,
        utm_medium: props.utm_medium,
        utm_campaign: props.utm_campaign,
        utm_content: props.utm_content || ''
      });
    }catch(_){}

    // Shopify fallback (email only)
    subscribeViaShopify(em, fullName, [
      'newsletter','archoil-quiz',
      (eng ? 'quiz_engine:'+eng : ''),
      (top ? 'quiz_top:'+top : '')
    ].filter(Boolean));

    window.__aq_gate_path = (wantsSms ? 'email+sms' : 'email');
    window.archoilQuizGateOk = true;
if (typeof window.archoilQuizRerender === 'function') window.archoilQuizRerender();
setTimeout(scrollTop, 0);
  });

  // Skip (behavior unchanged; shown as a text link so the main button carries the weight)
  var skip = el('button',{class:'aq-skiplink',type:'button'},['Skip and show results without 10% off']);
  skip.addEventListener('click', function(){
    window.__aq_gate_path = 'skip';
    try {
      var qa = window.archoilQuizAnswers || {};
      var engineLabel = qa.q1_engine ? getOptionLabel('q1_engine', qa.q1_engine) : '';
      var runId = aqRunId();

      trackKlaviyo('Archoil Quiz Gate Skipped', {
        quiz_run_id: runId,
        quiz_engine: engineLabel,
        skipped_at: new Date().toISOString(),
        entry_source: getEntrySource()
      });

      trackGA4('archoil_quiz_gate_skipped', {
        quiz_run_id: runId,
        entry_source: getEntrySource(),
        quiz_engine: engineLabel
      });
    } catch(_) {}

    window.archoilQuizGateOk = true;
if (typeof window.archoilQuizRerender === 'function') window.archoilQuizRerender();
setTimeout(scrollTop, 0);
  });

  var actions = el('div',{class:'aq-gate-actions'},[primary]);
  card.appendChild(actions);
  card.appendChild(skip);
  stage.appendChild(card);

  updateSmsVisibility();
}


  /* -------------------------- Full-screen helpers ----------------------------- */
  function heroUrlFor(key){ return HERO_IMAGES[key] || HERO_IMAGES.default; }
  function wrapFullScreen(root){
    var full = el('div',{class:'aq-full'},[]);
    var hero = el('div',{id:'aq-hero',class:'aq-hero'},[]);
    full.appendChild(hero);
    var panel = el('div',{class:'aq-panel'},[]);
    full.appendChild(panel);
    root.appendChild(full);
    return { hero:hero, panel:panel };
  }
  function setHeroBackground(heroEl, url, effect){
    if(!heroEl) return;
    if(effect==='out'){ heroEl.classList.remove('fade-in'); heroEl.classList.add('fade-out'); return; }
    heroEl.style.backgroundImage = 'url("'+ (url||'') +'")';
    heroEl.classList.remove('fade-out');
    heroEl.classList.add('fade-in');
    setTimeout(function(){ heroEl.classList.remove('fade-in'); }, 400);
  }

  // Animation direction for Next/Back
  var __aq_dir = 'forward';

  /* ---------------------- UI state + helpers for in-place selection ----------- */
  var state={ index:0, answers:{}, done:false, started:false };
  window.__aq_state = state; // expose for tiny helpers

function getQueryParam(name){
  try{
    var u = new URL(window.location.href);
    return (u.searchParams.get(name) || '').trim();
  }catch(_){ return ''; }
}

function aqSetCookie(name, value, minutes){
  try{
    var maxAge = Math.max(60, (minutes || 10) * 60); // seconds
    document.cookie = name + '=' + encodeURIComponent(value) +
      '; Max-Age=' + maxAge +
      '; Path=/' +
      '; SameSite=Lax';
  }catch(_){}
}

function aqAddUrlParam(url, key, value){
  try{
    if(!url) return url;
    var u = new URL(url, window.location.origin);
    u.searchParams.set(key, value);
    return u.toString();
  }catch(_){
    // Fallback for odd/relative URLs
    try{
      var sep = (url.indexOf('?') > -1) ? '&' : '?';
      return url + sep + encodeURIComponent(key) + '=' + encodeURIComponent(value);
    }catch(__){
      return url;
    }
  }
}

function prefillFromUrlIfPresent(){
  var eng = (getQueryParam('engine') || '').toLowerCase();

  // Normal visitors: clear flags and do nothing
  if (eng !== 'diesel' && eng !== 'gasoline') {
    try{
      sessionStorage.removeItem('aq_prefilled_engine');
      sessionStorage.removeItem('aq_skip_q1');
      sessionStorage.removeItem('aq_prefill_tracked');
      sessionStorage.removeItem('aq_started_sent');
    }catch(_){}
    return false;
  }

  // Mark entry source as popup (only if nothing else already set)
try {
  if (!sessionStorage.getItem('aq_entry_source')) {
    sessionStorage.setItem('aq_entry_source', 'popup');
  }
} catch(_){}

  // Mark prefilled session (used by visibleQuestions() to skip q1_engine)
  try{
    sessionStorage.setItem('aq_prefilled_engine', eng);
    sessionStorage.setItem('aq_skip_q1', '1');
  }catch(_){}

  // Start fresh so old answers don't conflict
  try { localStorage.removeItem(STORAGE_KEY); } catch(_){}
  try { sessionStorage.removeItem('aq_completed_sent'); } catch(_){}
  try { sessionStorage.removeItem('aq_run_id'); } catch(_){}
  window.__aq_gate_path = undefined;

  // Prefill engine and jump into quiz flow
  state.started = true;
  state.done = false;
  state.index = 0; // Q1 removed from visibleQuestions so index 0 becomes Q2
  state.answers = { q1_engine: eng };
  persist();

  // Fire "Quiz Started" once per tab/session for popup-prefill sessions
  try{
    if (sessionStorage.getItem('aq_started_sent') !== '1') {
      var runId = aqRunId();
var quizEngineLabel = (eng === 'diesel') ? 'Diesel' : 'Gasoline';
var src = getQueryParam('src') || 'popup';

trackKlaviyo('Archoil Quiz Started', {
  quiz_run_id: runId,
  started_at: new Date().toISOString(),
  start_method: 'prefill',
  quiz_engine: quizEngineLabel,
  source: src
});

trackGA4('archoil_quiz_started', {
  quiz_run_id: runId,
  entry_source: 'popup',
  quiz_engine: quizEngineLabel
});

      sessionStorage.setItem('aq_started_sent','1');
    }
  }catch(_){}

  // Track + set profile field ("quiz_engine") once per tab
  try{
    if (sessionStorage.getItem('aq_prefill_tracked') !== '1') {
      var src = getQueryParam('src') || 'popup';
      var quizEngineLabel = (eng === 'diesel') ? 'Diesel' : 'Gasoline';

      trackKlaviyo('Archoil Quiz Prefilled Engine', {
        quiz_run_id: aqRunId(),
        prefilled_engine: eng,
        source: src
      });

      // Profile property attribution (shows on the profile)
      if (window.klaviyo && typeof window.klaviyo.identify === 'function') {
        klaviyo.identify({ quiz_engine: quizEngineLabel });
      } else if (window._learnq) {
        _learnq.push(['identify', { quiz_engine: quizEngineLabel }]);
      }

      sessionStorage.setItem('aq_prefill_tracked','1');
    }
  }catch(_){}

  // Remove engine param so refresh doesn't re-trigger
  try{
    var url = new URL(window.location.href);
    url.searchParams.delete('engine'); // keep src if present
    window.history.replaceState({}, '', url.toString());
  }catch(_){}

  return true;
}

  function updateNextDisabled(stageEl){
    try{
      var qid = stageEl.getAttribute('data-qid');
      var required = stageEl.getAttribute('data-required') === 'true';
      var type = stageEl.getAttribute('data-type');
      var v = state.answers[qid];
      var answered = (type === 'multi') ? (Array.isArray(v) && v.length > 0) : !!v;
      var next = stageEl.querySelector('.aq-next');
      if(next){
        if(required && !answered) next.setAttribute('disabled','disabled');
        else next.removeAttribute('disabled');
      }
    }catch(_){}
  }

  function visibleQuestions(){
  var v = CONFIG.questions.slice()
    .sort(function(a,b){return (a.order||0)-(b.order||0);})
    .filter(function(q){ return shouldShowQuestion(q,state.answers); });

  // If engine was prefilled, remove Q1 from the flow
  try{
    var prefilled = sessionStorage.getItem('aq_prefilled_engine');
    if ((prefilled === 'diesel' || prefilled === 'gasoline') && state.answers && state.answers.q1_engine) {
      v = v.filter(function(q){ return q.id !== 'q1_engine'; });
    }
  }catch(_){}

  return v;
}

  // How many questions in each path?
  function totalForPath(a){
    if (a.q1_engine === 'diesel')   return 7;
    if (a.q1_engine === 'gasoline') return 6;
    return null;
  }

  function syncLabelHeights(){
    try{
      var root = byId('archoil-quiz-root'); if(!root) return;
      var bottoms = root.querySelectorAll('#aq-panel-body .aq-options .aq-option .half-bottom');
      if(!bottoms.length){ root.style.removeProperty('--aq-label-h'); return; }
      var isMobile = window.matchMedia('(max-width: 640px)').matches;
      var base = isMobile ? 100 : 84;
      var maxH = base;
      bottoms.forEach(function(b){ maxH = Math.max(maxH, b.scrollHeight); });
      root.style.setProperty('--aq-label-h', maxH + 'px');
    }catch(_){}
  }

  function tidyLabel(s){
    return String(s)
      .replace(/\bNewer diesel\b/g, 'Newer\u00A0diesel')
      .replace(/\bOlder diesel\b/g, 'Older\u00A0diesel')
      .replace(/\bHeavy duty\b/g, 'Heavy\u00A0duty')
      .replace(/\bDaily driver\b/g, 'Daily\u00A0driver')
      .replace(/\bPower Stroke\b/g, 'Power\u00A0Stroke')
      .replace(/\bgasoline vehicle\b/g, 'gasoline\u00A0vehicle')
      .replace(/\bClassic car\b/gi, 'Classic\u00A0car')
      .replace(/off-road/gi, 'off\u2011road');
  }

  function cameFromPopup(){
  try{
    var prefilled = sessionStorage.getItem('aq_prefilled_engine');
    return (prefilled === 'diesel' || prefilled === 'gasoline');
  }catch(_){ return false; }
}

  function render(){
    try{
      injectStyles();
      injectGridLayoutOverrides();
      var root=byId('archoil-quiz-root'); if(!root){ showError('Mount element #archoil-quiz-root not found.'); return; }
      clear(root);

      var wrapper = wrapFullScreen(root), hero = wrapper.hero, panel = wrapper.panel;

      // INTRO
      if (!state.done && !state.started){
        setHeroBackground(hero, heroUrlFor('intro'), 'in');

        var stageIntro = el('div',{class:'aq-panel-body aq-enter-up aq-intro'},[]);
        panel.appendChild(el('div',{},[])); panel.appendChild(stageIntro);

        var intro = el('div',{class:'aq-stage'},[]);
        intro.appendChild(el('h2',{class:'aq-h2 aq-center'},['Find Your Formula']));
        intro.appendChild(el('p',{class:'aq-subtle'},['Answer a few quick questions to get a personalized Archoil product recommendation.']));
        var startBtn = el('button',{class:'aq-btn aq-next',type:'button',onclick:function(){
          byId('aq-hero') && setHeroBackground(byId('aq-hero'), null, 'out');
          var body = stageIntro; body.classList.remove('aq-enter-up'); body.classList.add('aq-leave-up');
          setTimeout(function(){
            try {
  if (!sessionStorage.getItem('aq_entry_source')) {
    sessionStorage.setItem('aq_entry_source', 'hero');
  }
} catch(_){}
            state.started = true; state.index = 0; state.done = false; state.answers = {};
            window.__aq_restored = false;
            try{ localStorage.removeItem(STORAGE_KEY); }catch(_){}
            try{
  var runId = aqRunId();
  trackKlaviyo('Archoil Quiz Started', { quiz_run_id: runId, started_at: new Date().toISOString() });

  trackGA4('archoil_quiz_started', {
    quiz_run_id: runId,
    entry_source: 'hero'
  });
}catch(_){}

            __aq_dir = 'forward'; render(); scrollTop();
          }, 280);
        }},['Get Started']);
        intro.appendChild(startBtn);

        // Restore button if we have saved results
        var last = loadLastResults();
        if (last) {
          var restore = el('button', {
            class: 'aq-btn aq-skipbtn aq-restore',
            type: 'button',
            onclick: function () {
              state.started = true;
              state.index = 0;
              state.answers = last.answers || {};
              state.done = true;
              window.__aq_restored = true;
              window.archoilQuizGateOk = !!last.gate_ok;
              __aq_dir = 'forward';
              render(); scrollTop();
            }
          }, ['Return to my recommendations']);
          restore.style.marginTop = '10px';
          intro.appendChild(restore);
        }

        stageIntro.appendChild(intro);
        return;
      }

      // QUESTIONS / RESULTS
      var vq=visibleQuestions(); if(vq.length===0){ showError('No visible questions. Did you answer Q1?'); return; }
      var idx=Math.min(state.index,vq.length-1); state.index=idx;
      var current = vq[idx];
      var totalPath = totalForPath(state.answers);

      var answeredBefore = vq.slice(0, idx).filter(function(q){
        return isAnswered(q, state.answers);
      }).length;

      var progress = state.done
        ? 100
        : (totalPath ? Math.round((answeredBefore / totalPath) * 100) : 0);

      setHeroBackground(hero, heroUrlFor(current ? current.id : 'default'), 'in');

      var leftLabel;
      if (state.done) leftLabel = 'Complete';
      else if (totalPath) leftLabel = 'Question ' + String(idx + 1) + ' of ' + String(totalPath);
      else leftLabel = 'Question ' + String(idx + 1);

      var meta = el('div',{class:'aq-meta'},[
        el('div',{},[leftLabel]),
        el('div',{},[String(progress), '%'])
      ]);

      var prog=el('div',{class:'aq-progress'},[
        el('div',{class:'track'},[ el('div',{class:'fill',style:'width:'+progress+'%'},[]) ])
      ]);
      panel.appendChild(meta);

// Show this only for popup visitors (engine prefilled)
if (!state.done && cameFromPopup()) {
  panel.appendChild(el('div',{class:'aq-popup-msg'},[
    'You’re almost there, just answer a few quick questions, then subscribe to get 10% off your first order plus your personalized product recommendation.'
  ]));
}

panel.appendChild(prog);

// Put 10% OFF under the percentage (right side) for popup visitors during the quiz
if (!state.done && cameFromPopup()) {
  prog.appendChild(el('div',{class:'aq-tenoff'},['10% OFF']));
}

      var animClass = (__aq_dir==='forward' ? 'aq-enter-up' : 'aq-enter-down');
      var stage=el('div',{
        class:'aq-panel-body ' + animClass,
        id:'aq-panel-body',
        'data-qid': current.id,
        'data-type': current.type,
        'data-required': String(!!current.required),
        'data-max': String(current.max_select||'')
      },[]);
      panel.appendChild(stage);

      if(!state.done){
        // QUESTION
        trackQuizStep(current);
        stage.appendChild(el('div',{class:'aq-stage'},[
          el('h2',{class:'aq-h2'},[current?current.title:''])
        ]));

        var optWrap=el('div',{class:'aq-options'});
        var opts=CONFIG.options.filter(function(o){return o.question_id===current.id;});
        var maxSel=current.max_select||Infinity;

        opts.forEach(function(opt){
          var selected=(current.type==='multi') ? (Array.isArray(state.answers[current.id]) && state.answers[current.id].includes(opt.option_id)) : (state.answers[current.id]===opt.option_id);
          var childrenTop=[];
          if (FEATURES.icons) {
            var key = iconKeyForOption(current.id, opt.option_id);
            childrenTop = [ renderIconElement(key, opt.label) ];
          }
          var btn=el('button',{class:'aq-option'+(selected?' selected':''),type:'button'},[
            el('div',{class:'half-top'},childrenTop),
            el('div',{class:'half-bottom'},[ tidyLabel(opt.label) ])
          ]);

          btn.addEventListener('click', function(e){
            var stageEl = byId('aq-panel-body');
            if(current.type === 'multi'){
              var arr = Array.isArray(state.answers[current.id]) ? state.answers[current.id].slice() : [];
              var isSelected = btn.classList.contains('selected');
              if(isSelected){
                btn.classList.remove('selected');
                arr = arr.filter(function(x){ return x !== opt.option_id; });
              }else{
                if(arr.length < maxSel){
                  btn.classList.add('selected');
                  arr.push(opt.option_id);
                }
              }
              state.answers[current.id] = arr;
              var counter = stageEl.querySelector('.aq-subtle');
              if(counter){
                counter.textContent = 'Selected ' + arr.length + (current.max_select ? ' / ' + current.max_select : '');
              }
            }else{
              var wrap = e.currentTarget.closest('.aq-options');
              if(wrap){ wrap.querySelectorAll('.aq-option.selected').forEach(function(n){ n.classList.remove('selected'); }); }
              btn.classList.add('selected');
              state.answers[current.id] = opt.option_id;
            }
            persist();
            updateNextDisabled(stageEl);
          });

          optWrap.appendChild(btn);
        });
        stage.appendChild(optWrap);
        syncLabelHeights();

        if(current.type==='multi'){
          var selCount = Array.isArray(state.answers[current.id]) ? state.answers[current.id].length : 0;
          stage.appendChild(el('div',{class:'aq-subtle'},[
            'Selected ', String(selCount), (current.max_select ? ' / ' + String(current.max_select) : '')
          ]));
        }

        var __aq_sync_timer = null;
        window.addEventListener('resize', function(){
          clearTimeout(__aq_sync_timer);
          __aq_sync_timer = setTimeout(syncLabelHeights, 100);
        });

        var actions=el('div',{class:'aq-actions'});
        var back = el('button', {
          class: 'aq-btn aq-back',
          type: 'button',
          onclick: function () {
            var heroEl = byId('aq-hero');
            setHeroBackground(heroEl, null, 'out');
            var body = byId('aq-panel-body');
            body.classList.remove('aq-enter-up', 'aq-enter-down');
            body.classList.add('aq-leave-down');

            setTimeout(function () {
              var vq2 = visibleQuestions();
              var pos = vq2.findIndex(function (q) { return q.id === current.id; });
              if (pos > 0) state.index = pos - 1;
              else state.index = 0;
              state.done = false;
              __aq_dir = 'back';
              render();
              scrollTop();
            }, 280);
          }
        }, ['< Back']);
        if (idx === 0) back.setAttribute('disabled', 'disabled');

        var next = el('button', {
          class: 'aq-btn aq-next',
          type: 'button',
          onclick: function () {
            if (current.required && !isAnswered(current, state.answers)) return;

            var heroEl = byId('aq-hero');
            setHeroBackground(heroEl, null, 'out');
            var body = byId('aq-panel-body');
            body.classList.remove('aq-enter-up', 'aq-enter-down');
            body.classList.add('aq-leave-up');

            setTimeout(function () {
              var vq2 = visibleQuestions();
              var total2 = vq2.length;
              var pos = vq2.findIndex(function (q) { return q.id === current.id; });

              if (pos > -1 && pos < total2 - 1) {
                state.index = pos + 1;
                state.done = false;
              } else {
                state.done = true;
              }

              __aq_dir = 'forward';
              render();
              scrollTop();
            }, 280);
          }
        }, [ (totalPath && idx === (totalPath - 1)) ? 'See Results' : 'Next Question' ]);

        if(current.required && !isAnswered(current, state.answers)) next.setAttribute('disabled','disabled');

        actions.appendChild(back); actions.appendChild(next); actions.appendChild(el('div',{},[]));
        stage.appendChild(actions);

      }else{
        // RESULTS
        setHeroBackground(hero, heroUrlFor('results'), 'in');

        var gateShowing = FEATURES.gate && !window.archoilQuizGateOk;
        var head=el('div',{class:'aq-stage'},[]);
        if (gateShowing) {
          head.appendChild(el('h2',{class:'aq-h2 aq-center',style:'margin-bottom:8px'},['Your recommendations are ready']));
        } else {
          head.appendChild(el('h2',{class:'aq-h2',style:'margin-bottom:8px'},['Your recommendations']));
          head.appendChild(el('p',{class:'aq-subtle'},['Based on your answers, here are the top picks.']));
        }
        stage.appendChild(head);

        var scored=scoreWithMatrix(state.answers);

        var topN = Number((CONFIG.settings.find(function(s){return s.key==='always_include_top_n';})||{value:3}).value);
        var rankedBase = scored.ranked.filter(function(id){ return id !== 'UDK' && id !== 'UWDK' && id !== 'WDFK'; });
        var list = rankedBase.map(function(id){ return CONFIG.products.find(function(p){return p.id===id;}); })
                             .filter(Boolean)
                             .slice(0, topN);

        // Save snapshot for "Return to my recommendations"
        saveLastResults({
          ts: Date.now(),
          answers: state.answers,
          results: list.map(function(p){ return p.id; }),
          top: list[0] ? list[0].id : null,
          top_url: list[0] ? list[0].url : null,
          gate_ok: !FEATURES.gate || !!window.archoilQuizGateOk
        });

        // --- DFSK → WDFK swap when winter-eligible (coldYes || eligibleSometimes)
        var wantsAG = Array.isArray(state.answers.d4_benefits) && state.answers.d4_benefits.indexOf('anti_gel') > -1;
        var coldYes = (state.answers.d6_cold === 'yes');
        var eligibleSometimes = (state.answers.d6_cold === 'sometimes') && (isWinterMonth() || wantsAG);

        var iDFSK = list.findIndex(function(p){ return p && p.id === 'DFSK'; });
        if (coldYes || eligibleSometimes) {
          if (iDFSK > -1) {
            var winterKit = findProduct('WDFK');
            if (winterKit) {
              list[iDFSK] = winterKit;
              scored.scores.WDFK = scored.scores.DFSK || 0;
            }
          }
        }

        // --- Ultimate kit promotions
        (function(){
          var a = state.answers || {};
          if (a.q1_engine !== 'diesel') return;

          var psOrStiction =
            (a.d2_vehicle === 'powerstroke_6_0_7_3') ||
            (Array.isArray(a.d4_benefits) && a.d4_benefits.indexOf('stiction') > -1);

          var wantsAG = Array.isArray(a.d4_benefits) && a.d4_benefits.indexOf('anti_gel') > -1;
          var coldYes = (a.d6_cold === 'yes');
          var eligibleSometimes = (a.d6_cold === 'sometimes') && (isWinterMonth() || wantsAG);

          if (!(coldYes || eligibleSometimes)) return;
          if (!psOrStiction) return;

          var ultimate = findProduct('UWDK');
          if (!ultimate) return;

          list = list.filter(function(p){ return p && p.id !== 'UDK' && p.id !== 'WDFK' && p.id !== 'DFSK' && p.id !== 'UWDK'; });
          list.unshift(ultimate);
          if (list.length > topN) list = list.slice(0, topN);

          var bestScore = 0;
          for (var i=0;i<list.length;i++){
            var pid = list[i].id;
            if (pid === 'UWDK') continue;
            bestScore = Math.max(bestScore, Number(scored.scores[pid] || 0));
          }
          if (bestScore === 0) {
            for (var j=0;j<rankedBase.length;j++){
              bestScore = Math.max(bestScore, Number(scored.scores[rankedBase[j]] || 0
));
            }
          }
          if (bestScore > 0) scored.scores['UWDK'] = bestScore;
        })();

        (function(){
          var a = state.answers || {};
          if (a.q1_engine !== 'diesel') return;

          var psOrStiction =
            (a.d2_vehicle === 'powerstroke_6_0_7_3') ||
            (Array.isArray(a.d4_benefits) && a.d4_benefits.indexOf('stiction') > -1);

          var wantsAG = Array.isArray(a.d4_benefits) && a.d4_benefits.indexOf('anti_gel') > -1;
var coldYes = (a.d6_cold === 'yes');
var eligibleSometimes = (a.d6_cold === 'sometimes') && (isWinterMonth() || wantsAG);
var notWinterEligible = (!coldYes && !eligibleSometimes);


          if (!notWinterEligible) return;
          if (!psOrStiction) return;

          var ultimate = findProduct('UDK');
          if (!ultimate) return;

          // Remove winter kits then promote UDK to slot #1
          list = list.filter(function(p){ return p && p.id !== 'DFSK' && p.id !== 'WDFK' && p.id !== 'UWDK' && p.id !== 'UDK'; });
          list.unshift(ultimate);
          if (list.length > topN) list = list.slice(0, topN);

          var bestScore = 0;
          for (var i=0;i<list.length;i++){
            var pid = list[i].id;
            if (pid === 'UDK') continue;
            bestScore = Math.max(bestScore, Number(scored.scores[pid] || 0));
          }
          if (bestScore === 0) {
            for (var j=0;j<rankedBase.length;j++){
              bestScore = Math.max(bestScore, Number(scored.scores[rankedBase[j]] || 0));
            }
          }
          if (bestScore > 0) scored.scores['UDK'] = bestScore;
        })();

        window.archoilQuizAnswers     = state.answers;
        window.archoilTopProductName  = aqProductReportingName(list[0]);
        window.archoilQuizRerender    = render;

        if (FEATURES.gate && !window.archoilQuizGateOk) {
          trackQuizGateViewed();
          renderInlineGate(stage);
          return;
        }

        try {
  // Only arm the Attentive offer if they SKIPPED the gate
  if (window.__aq_gate_path === 'skip') {
    aqSetCookie('aq_postquiz_offer', '1', 20); // 20 minutes
  }
} catch(_) {}

        if (!sessionStorage.getItem('aq_completed_sent')) {
          var a = state.answers || {};
          var isDiesel = a.q1_engine === 'diesel';
          var benefitProps = buildBenefitProps(a);
          var props = Object.assign({
            quiz_run_id: aqRunId(),
            gate_path: (window.__aq_gate_path || (FEATURES.gate ? 'unknown' : 'disabled')),
            quiz_engine: a.q1_engine ? getOptionLabel('q1_engine', a.q1_engine) : '',
            quiz_vehicle: isDiesel
              ? (a.d2_vehicle ? getOptionLabel('d2_vehicle', a.d2_vehicle) : '')
              : (a.g2_vehicle ? getOptionLabel('g2_vehicle', a.g2_vehicle) : ''),
            quiz_miles: isDiesel
              ? (a.d3_miles ? getOptionLabel('d3_miles', a.d3_miles) : '')
              : (a.g3_miles ? getOptionLabel('g3_miles', a.g3_miles) : ''),
            quiz_use: isDiesel
              ? (a.d5_use ? getOptionLabel('d5_use', a.d5_use) : '')
              : (a.g5_use ? getOptionLabel('g5_use', a.g5_use) : ''),
            quiz_cold: (a.d6_cold ? getOptionLabel('d6_cold', a.d6_cold) : ''),
            quiz_multi: isDiesel
              ? (a.d7_multi ? getOptionLabel('d7_multi', a.d7_multi) : '')
              : (a.g6_multi ? getOptionLabel('g6_multi', a.g6_multi) : ''),
            quiz_top_product: aqProductReportingName(list[0]),
            quiz_completed_at: new Date().toISOString()
          }, benefitProps);
          props.entry_source = getEntrySource();

          try {
            if (window.klaviyo && typeof window.klaviyo.identify === 'function') {
              var p2 = {}; for (var k in props){ if(k!=='email'&&k!=='first_name'&&k!=='last_name'&&k!=='full_name') p2[k]=props[k]; }
              klaviyo.identify(p2);
            } else if (window._learnq) {
              var legacy2 = Object.assign({}, props);
              _learnq.push(['identify', legacy2]);
            }
          } catch(_) {}
          props.entry_source = getEntrySource();
          try{
  trackGA4('archoil_quiz_completed', {
    quiz_run_id: props.quiz_run_id,
    entry_source: getEntrySource(),
    quiz_engine: props.quiz_engine || ''
  });
}catch(_){}

          trackKlaviyo('Archoil Quiz Completed', props);
          sessionStorage.setItem('aq_completed_sent','1');
        }

        var ids=list.map(function(p){return p.id;});
        var maxScore=Math.max(1e-9, Math.max.apply(null, ids.map(function(id){return scored.scores[id]||0;})));
        var perc={}; ids.forEach(function(id){ perc[id]=Math.round(Math.max(0,(scored.scores[id]||0))/maxScore*100); });

        var grid=el('div',{class:'aq-results-grid'});
        list.forEach(function(p,i){
          var card = el('a', { class: 'aq-result' + (i===0 ? ' aq-ring' : ''), href: (p.url ? aqAddUrlParam(p.url, 'pm', '1') : '#')}, []);
          card.appendChild(el('div',{class:'aq-badge'},[String(i+1)]));
          if(i===0) card.appendChild(el('span',{class:'aq-best'},['Best match']));
          var productImageEl = p.image ? el('img',{class:'aq-img',src:p.image,alt:p.name||p.id},[]) : null;
          if(productImageEl) card.appendChild(productImageEl);
          var body=el('div',{class:'aq-res-body'},[]);
          var row=el('div',{class:'aq-row'},[
            el('div',{style:'font-weight:600'},[p.name||p.id]),
            el('div',{class:'aq-chip'},[String(perc[p.id]||0)+'%'])
          ]);
          body.appendChild(row);
          var productPriceEl = el('div',{style:'color:#374151;font-size:14px;margin:2px 0'},['Checking current price…']);
          body.appendChild(productPriceEl);
          var bar=el('div',{class:'aq-bar'},[ el('div',{style:'width:'+(perc[p.id]||0)+'%'},[]) ]);
          body.appendChild(bar);
          if(p.blurb) body.appendChild(el('div',{style:'color:#6b7280;font-size:14px'},[p.blurb]));
          card.appendChild(body);
          grid.appendChild(card);
          aqUpdateResultCardFromShopify(p, productImageEl, productPriceEl);
        });
        stage.appendChild(grid);

        if(list[0]) stage.appendChild(buildWhyElement(list[0], state.answers));

        var actions2=el('div',{class:'aq-retake'},[
          el('button',{class:'aq-btn',type:'button',onclick:function(){
            setHeroBackground(byId('aq-hero'), null, 'out');
            var body = byId('aq-panel-body'); body.classList.add('aq-leave-down');
            setTimeout(function(){
              window.__aq_restored = false;
              state.index=0; state.done=false; state.answers={}; state.started=false;
              sessionStorage.removeItem('aq_completed_sent');
              sessionStorage.removeItem('aq_run_id');
              window.__aq_gate_path = undefined;
              try{ localStorage.removeItem(STORAGE_KEY); }catch(_){}
              __aq_dir='back'; render(); scrollTop();
            }, 280);
          }},['Retake']),
          el('a',{class:'aq-btn aq-next',href: (list[0] && list[0].url) ? aqAddUrlParam(list[0].url, 'pm', '1') : "#"},['Go to best match'])
        ]);
        stage.appendChild(actions2);
      }
    }catch(e){ showError(e.message||e); }
  }

function captureEntryAttribution(){
  try{
    // Don’t overwrite if we already captured it this tab
    var existing = sessionStorage.getItem('aq_entry_source');
    if (existing) return;

    // Prefer explicit src= tag
    var src = (getQueryParam('src') || '').trim();
    if (src === 'klaviyo_popup') src = 'popup';
    if (src) {
      sessionStorage.setItem('aq_entry_source', src);
    } else {
      // Fallback: build from UTMs if present
      var utm_source   = (getQueryParam('utm_source') || '').trim();
      var utm_medium   = (getQueryParam('utm_medium') || '').trim();
      var utm_campaign = (getQueryParam('utm_campaign') || '').trim();
      var utm_content  = (getQueryParam('utm_content') || '').trim();

      if (utm_source || utm_medium || utm_campaign || utm_content) {
        // Keep it short but useful
        var parts = [];
        if (utm_source) parts.push(utm_source);
        if (utm_medium) parts.push(utm_medium);
        if (utm_campaign) parts.push(utm_campaign);
        if (utm_content) parts.push(utm_content);
        sessionStorage.setItem('aq_entry_source', parts.join('|'));
      }
    }

    // Store UTMs separately too (handy for Klaviyo + GA4)
    var keys = ['utm_source','utm_medium','utm_campaign','utm_content','utm_term'];
    keys.forEach(function(k){
      var v = (getQueryParam(k) || '').trim();
      if (v) sessionStorage.setItem('aq_' + k, v);
    });
  }catch(_){}
}

  function start(){
    try{
      restore();
      var mount = byId('archoil-quiz-root');
      if(!mount){ showError('Add <div id="archoil-quiz-root"></div> to your section.'); return; }
      injectStyles();
      injectGridLayoutOverrides();
      captureEntryAttribution();
      prefillFromUrlIfPresent();
      trackQuizViewed();
      render();
      window.__archoil_quiz_mounted = true;
    }catch(e){ showError(e.message||e); }
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', start); else start();

})();